module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 30);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = require("vue");

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return off; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return once; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hasClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return removeClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getStyle; });
/* unused harmony export setStyle */
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* istanbul ignore next */



var isServer = vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.$isServer;
var SPECIAL_CHARS_REGEXP = /([\:\-\_]+(.))/g;
var MOZ_HACK_REGEXP = /^moz([A-Z])/;
var ieVersion = isServer ? 0 : Number(document.documentMode);

/* istanbul ignore next */
var trim = function trim(string) {
  return (string || '').replace(/^[\s\uFEFF]+|[\s\uFEFF]+$/g, '');
};
/* istanbul ignore next */
var camelCase = function camelCase(name) {
  return name.replace(SPECIAL_CHARS_REGEXP, function (_, separator, letter, offset) {
    return offset ? letter.toUpperCase() : letter;
  }).replace(MOZ_HACK_REGEXP, 'Moz$1');
};

/* istanbul ignore next */
var on = function () {
  if (!isServer && document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler);
      }
    };
  }
}();

/* istanbul ignore next */
var off = function () {
  if (!isServer && document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false);
      }
    };
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler);
      }
    };
  }
}();

/* istanbul ignore next */
var once = function once(el, event, fn) {
  var listener = function listener() {
    if (fn) {
      fn.apply(this, arguments);
    }
    off(el, event, listener);
  };
  on(el, event, listener);
};

/* istanbul ignore next */
function hasClass(el, cls) {
  if (!el || !cls) return false;
  if (cls.indexOf(' ') !== -1) throw new Error('className should not contain space.');
  if (el.classList) {
    return el.classList.contains(cls);
  } else {
    return (' ' + el.className + ' ').indexOf(' ' + cls + ' ') > -1;
  }
}

/* istanbul ignore next */
function addClass(el, cls) {
  if (!el) return;
  var curClass = el.className;
  var classes = (cls || '').split(' ');

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.add(clsName);
    } else if (!hasClass(el, clsName)) {
      curClass += ' ' + clsName;
    }
  }
  if (!el.classList) {
    el.className = curClass;
  }
}

/* istanbul ignore next */
function removeClass(el, cls) {
  if (!el || !cls) return;
  var classes = cls.split(' ');
  var curClass = ' ' + el.className + ' ';

  for (var i = 0, j = classes.length; i < j; i++) {
    var clsName = classes[i];
    if (!clsName) continue;

    if (el.classList) {
      el.classList.remove(clsName);
    } else if (hasClass(el, clsName)) {
      curClass = curClass.replace(' ' + clsName + ' ', ' ');
    }
  }
  if (!el.classList) {
    el.className = trim(curClass);
  }
}

/* istanbul ignore next */
var getStyle = ieVersion < 9 ? function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'styleFloat';
  }
  try {
    switch (styleName) {
      case 'opacity':
        try {
          return element.filters.item('alpha').opacity / 100;
        } catch (e) {
          return 1.0;
        }
      default:
        return element.style[styleName] || element.currentStyle ? element.currentStyle[styleName] : null;
    }
  } catch (e) {
    return element.style[styleName];
  }
} : function (element, styleName) {
  if (isServer) return;
  if (!element || !styleName) return null;
  styleName = camelCase(styleName);
  if (styleName === 'float') {
    styleName = 'cssFloat';
  }
  try {
    var computed = document.defaultView.getComputedStyle(element, '');
    return element.style[styleName] || computed ? computed[styleName] : null;
  } catch (e) {
    return element.style[styleName];
  }
};

/* istanbul ignore next */
function setStyle(element, styleName, value) {
  if (!element || !styleName) return;

  if ((typeof styleName === 'undefined' ? 'undefined' : _typeof(styleName)) === 'object') {
    for (var prop in styleName) {
      if (styleName.hasOwnProperty(prop)) {
        setStyle(element, prop, styleName[prop]);
      }
    }
  } else {
    styleName = camelCase(styleName);
    if (styleName === 'opacity' && ieVersion < 9) {
      element.style.filter = isNaN(value) ? '' : 'alpha(opacity=' + value * 100 + ')';
    } else {
      element.style[styleName] = value;
    }
  }
}

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return normalizeComponent; });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
        injectStyles.call(
          this,
          (options.functional ? this.parent : this).$root.$options.shadowRoot
        )
      }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return noop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return hasOwn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return toObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return getValueByPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return getPropByPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return generateId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return valueEquals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return escapeRegexpString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return arrayFindIndex; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return arrayFind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return coerceTruthyValueToArray; });
/* unused harmony export isIE */
/* unused harmony export isEdge */
/* unused harmony export isFirefox */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return autoprefixer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return chunk; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return substr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return getTree; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return arr2table; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return findInArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return filterInArray; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return treeDeep; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return recursiveLoop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return deepClone; });
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var hasOwnProperty = Object.prototype.hasOwnProperty;

function noop() {}

function hasOwn(obj, key) {
  return hasOwnProperty.call(obj, key);
}

function extend(to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to;
}

function toObject(arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res;
}

var getValueByPath = function getValueByPath(object, prop) {
  prop = prop || '';
  var paths = prop.split('.');
  var current = object;
  var result = null;
  for (var i = 0, j = paths.length; i < j; i++) {
    var path = paths[i];
    if (!current) break;

    if (i === j - 1) {
      result = current[path];
      break;
    }
    current = current[path];
  }
  return result;
};

function getPropByPath(obj, path, strict) {
  var tempObj = obj;
  path = path.replace(/\[(\w+)\]/g, '.$1');
  path = path.replace(/^\./, '');

  var keyArr = path.split('.');
  var i = 0;
  for (var len = keyArr.length; i < len - 1; ++i) {
    if (!tempObj && !strict) break;
    var key = keyArr[i];
    if (key in tempObj) {
      tempObj = tempObj[key];
    } else {
      if (strict) {
        throw new Error('please transfer a valid prop path to form item!');
      }
      break;
    }
  }
  return {
    o: tempObj,
    k: keyArr[i],
    v: tempObj ? tempObj[keyArr[i]] : null
  };
}

var generateId = function generateId() {
  return Math.floor(Math.random() * 10000);
};

var valueEquals = function valueEquals(a, b) {
  // see: https://stackoverflow.com/questions/3115982/how-to-check-if-two-arrays-are-equal-with-javascript
  if (a === b) return true;
  if (!(a instanceof Array)) return false;
  if (!(b instanceof Array)) return false;
  if (a.length !== b.length) return false;
  for (var i = 0; i !== a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
};

var escapeRegexpString = function escapeRegexpString() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
};

// TODO: use native Array.find, Array.findIndex when IE support is dropped
var arrayFindIndex = function arrayFindIndex(arr, pred) {
  for (var i = 0; i !== arr.length; ++i) {
    if (pred(arr[i])) {
      return i;
    }
  }
  return -1;
};

var arrayFind = function arrayFind(arr, pred) {
  var idx = arrayFindIndex(arr, pred);
  return idx !== -1 ? arr[idx] : undefined;
};

// coerce truthy value to array
var coerceTruthyValueToArray = function coerceTruthyValueToArray(val) {
  if (Array.isArray(val)) {
    return val;
  } else if (val) {
    return [val];
  } else {
    return [];
  }
};

var isIE = function isIE() {
  return !vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.$isServer && !isNaN(Number(document.documentMode));
};

var isEdge = function isEdge() {
  return !vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.$isServer && navigator.userAgent.indexOf('Edge') > -1;
};

var isFirefox = function isFirefox() {
  return !vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.$isServer && !!window.navigator.userAgent.match(/firefox/i);
};

var autoprefixer = function autoprefixer(style) {
  if ((typeof style === 'undefined' ? 'undefined' : _typeof(style)) !== 'object') return style;
  var rules = ['transform', 'transition', 'animation'];
  var prefixes = ['ms-', 'webkit-'];
  rules.forEach(function (rule) {
    var value = style[rule];
    if (rule && value) {
      prefixes.forEach(function (prefix) {
        style[prefix + rule] = value;
      });
    }
  });
  return style;
};

var chunk = function chunk(data, count) {
  var result = [];
  if (!(data instanceof Array)) return data;
  data.forEach(function (item, index) {
    var temp = Math.floor(index / count);
    if (!(result[temp] instanceof Array)) {
      result[temp] = [];
    }
    result[temp].push(item);
  });
  return result;
};

function strlen(str) {
  var strlen = 0;
  for (var i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 128) {
      strlen += 2;
    } else {
      strlen++;
    }
  }
  return strlen;
}

var substr = function substr(str, len) {
  var strlength = 0;
  var s = '';
  var plen = 0;
  if (strlen(str) <= len) {
    return str;
  }
  for (var i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 128) {
      strlength += 2;
      plen = 2;
    } else {
      strlength++;
      plen = 1;
    }
    s += str.charAt(i);
    if (strlength >= len - plen) {
      return s + '...';
    }
  }
  return s;
};

/**
 * 重构树数组
 * @param {Array} _array_tree 树的数组
 * @param {String} son 子节点键
 * @param {Number} level 层级默认值
 */
function getTree(_array_tree) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var parent = arguments[3];

  var _Object$assign = Object.assign({
    key: 'key',
    value: 'value',
    son: 'children',
    pKey: 'parent',
    appendPKey: false,
    selected: [],
    multiple: true,
    leaf: false,
    disabledSelect: [],
    exactMatch: false,
    keyword: ''
  }, options),
      key = _Object$assign.key,
      value = _Object$assign.value,
      son = _Object$assign.son,
      pKey = _Object$assign.pKey,
      selected = _Object$assign.selected,
      multiple = _Object$assign.multiple,
      leaf = _Object$assign.leaf,
      disabledSelect = _Object$assign.disabledSelect,
      exactMatch = _Object$assign.exactMatch,
      keyword = _Object$assign.keyword,
      appendPKey = _Object$assign.appendPKey;

  var tree = [];

  var _loop = function _loop(i) {
    var _tree = {};
    var sub = null;
    for (var _key in _array_tree[i]) {
      if (_key === son && _array_tree[i][son].length) {
        sub = _array_tree[i][son];
      } else {
        _tree[_key] = _array_tree[i][_key];
      }
    }
    _tree['level'] = level;
    // 不输出禁选
    if (disabledSelect.length > 0) {
      if (disabledSelect && disabledSelect[0] && _typeof(disabledSelect[0]) === 'object') {
        if (disabledSelect.find(function (item) {
          return item && item[key] && item[key] === _tree[key] && item[value] === _tree[value];
        })) return 'continue';
      } else {
        if (disabledSelect.includes(_tree[key])) return 'continue';
      }
    }
    if (parent && parent['level'] >= 0) {
      var _tree$pKey;

      _tree[pKey] = (_tree$pKey = {}, _defineProperty(_tree$pKey, key, parent[key]), _defineProperty(_tree$pKey, value, parent[value]), _defineProperty(_tree$pKey, 'level', parseInt(parent['level'])), _tree$pKey);
      if (parent.parent) {
        _tree['parent'].parent = parent.parent;
      }
      if (appendPKey) {
        _tree[key] = [parent[key], _tree[key]].join('-');
      }
    }
    if (!_tree['disabled']) {
      if (selected && selected[0] && _typeof(selected[0]) === 'object') {
        _tree['selected'] = selected.length ? !!selected.find(function (item) {
          return item && item[key] !== undefined && item[key] === _tree[key] && (exactMatch ? item['level'] === _tree['level'] : true);
        }) : false;
      } else {
        _tree['selected'] = selected.length ? selected.includes(_tree[key]) : false;
      }
    }
    if (sub) {
      var sub_array = getTree(sub, options, level + 1, _tree);
      if (sub_array && sub_array.length) {
        _tree[son] = sub_array;
        if (leaf) {
          var _count = sub_array.filter(function (item) {
            return item.selected;
          }).length;
          if (multiple) {
            _tree['selected'] = sub_array.length === _count;
            _tree['indeterminate'] = sub_array.length > _count && _count > 0;
          } else {
            // _tree['selected'] = _count > 0
          }
        }
      } else if (sub_array.length === 0 && leaf) {
        return 'continue';
      } else if (keyword && _tree[value] && _tree[value].toLowerCase().indexOf(keyword.toLowerCase()) === -1) {
        return 'continue';
      }
    } else {
      _tree['leaf'] = true;
      if (keyword && _tree[value] && _tree[value].toLowerCase().indexOf(keyword.toLowerCase()) === -1) {
        return 'continue';
      }
    }
    tree.push(_tree);
  };

  for (var i in _array_tree) {
    var _ret = _loop(i);

    if (_ret === 'continue') continue;
  }
  return tree;
}
/**
 * 树数组转成一维数组
 * @param {Array} _array_tree 树的数组
 * @param {String} son 子节点键
 * @param {Boolean} leaf 是否只取叶节点
 * @param {Number} level 层级默认值
 */
function arr2table(_array_tree) {
  var son = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'children';
  var leaf = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var level = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var parent = arguments[4];

  var tree = [];
  for (var i in _array_tree) {
    var _tree2 = _array_tree[i];
    if (Array.isArray(_tree2)) {
      tree = tree.concat(arr2table(_tree2, son, leaf, level + 1, _tree2));
    } else {
      var _sub = _tree2[son];
      _tree2['level'] = level;
      if (leaf && (!_sub || !_sub.length)) {
        tree.push(_tree2);
      } else if (!leaf) {
        tree.push(_tree2);
      }
      if (_sub) {
        var sub_array = arr2table(_sub, son, leaf, level + 1, _tree2);
        tree = tree.concat(sub_array);
      }
    }
  }
  return tree;
}
function findInArray(key, value, arr) {
  var sub = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'sub';
  var level = arguments[4];
  var output = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];

  if (typeof key !== 'string' || value === undefined || (typeof arr === 'undefined' ? 'undefined' : _typeof(arr)) !== 'object') return {};
  for (var i in arr) {
    var item = arr[i];
    if (item[key] !== undefined && item[key] === value && item['level'] === level) {
      output.push(item);
    } else if (item.hasOwnProperty(sub) && _typeof(item[sub]) === 'object') {
      findInArray(key, value, item[sub], sub, level, output);
    } else if (Array.isArray(item)) {
      findInArray(key, value, item, sub, level, output);
    }
  }
  return output.length > 0 ? output[0] : {};
}
function filterInArray(key, value, arr) {
  var sub = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'sub';
  var level = arguments[4];

  if (typeof key !== 'string' || value === undefined || (typeof arr === 'undefined' ? 'undefined' : _typeof(arr)) !== 'object') return [];
  var output = [];
  for (var i in arr) {
    var item = arr[i];
    if (Array.isArray(item)) {
      output = output.concat(filterInArray(key, value, item, sub, level));
    } else {
      if (item[key] !== undefined && item[key] === value && item['level'] === level) {
        output.push(item);
        return output;
      } else if (item.hasOwnProperty(sub) && _typeof(item[sub]) === 'object') {
        output = output.concat(filterInArray(key, value, item[sub], sub, level));
      }
    }
  }
  return output;
}
function treeDeep(jsonData) {
  var children = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'children';

  var num = 0;
  function recursion(data, k) {
    num = Math.max(num, k);
    for (var x in data) {
      var obj = data[x];
      if (obj[children] && obj[children].length) {
        recursion(obj[children], k + 1);
      }
    }
  }
  recursion(jsonData, 1);
  return num;
}
function recursiveLoop(data) {
  var loopKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'parent';
  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'key';
  var output = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

  if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object' || data === null) {
    output.push(data);
  } else if (!(data instanceof Array)) {
    output.push(data[key] !== undefined ? data[key] : data);
    if (data.hasOwnProperty(loopKey)) {
      var _item = data[loopKey];
      recursiveLoop(_item, loopKey, key, output);
    }
  } else {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = data[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var item = _step.value;

        recursiveLoop(item, loopKey, key, output);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  return output;
}
function deepClone(source) {
  var sourceCopy = source instanceof Array ? [] : {};
  for (var item in source) {
    sourceCopy[item] = _typeof(source[item]) === 'object' ? deepClone(source[item]) : source[item];
  }
  return sourceCopy;
}

/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _broadcast(componentName, eventName, params) {
  this.$children.forEach(function (child) {
    var name = child.$options.componentName;

    if (name === componentName) {
      child.$emit.apply(child, [eventName].concat(params));
    } else {
      _broadcast.apply(child, [componentName, eventName].concat([params]));
    }
  });
}
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    dispatch: function dispatch(componentName, eventName, params) {
      var parent = this.$parent || this.$root;
      var name = parent.$options.componentName;

      while (parent && (!name || name !== componentName)) {
        parent = parent.$parent;

        if (parent) {
          name = parent.$options.componentName;
        }
      }
      if (parent) {
        parent.$emit.apply(parent, [eventName].concat(params));
      }
    },
    broadcast: function broadcast(componentName, eventName, params) {
      _broadcast.call(this, componentName, eventName, params);
    }
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (target) {
  for (var i = 1, j = arguments.length; i < j; i++) {
    var source = arguments[i] || {};
    for (var prop in source) {
      if (source.hasOwnProperty(prop)) {
        var value = source[prop];
        if (value !== undefined) {
          target[prop] = value;
        }
      }
    }
  }

  return target;
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);


var scrollBarWidth = void 0;

/* harmony default export */ __webpack_exports__["a"] = (function () {
  if (vue__WEBPACK_IMPORTED_MODULE_0___default.a.prototype.$isServer) return 0;
  if (scrollBarWidth !== undefined) return scrollBarWidth;

  var outer = document.createElement('div');
  outer.className = 'iw-scrollbar__wrap';
  outer.style.visibility = 'hidden';
  outer.style.width = '100px';
  outer.style.position = 'absolute';
  outer.style.top = '-9999px';
  document.body.appendChild(outer);

  var widthNoScroll = outer.offsetWidth;
  outer.style.overflow = 'scroll';

  var inner = document.createElement('div');
  inner.style.width = '100%';
  outer.appendChild(inner);

  var widthWithScroll = inner.offsetWidth;
  outer.parentNode.removeChild(outer);
  scrollBarWidth = widthNoScroll - widthWithScroll;

  return scrollBarWidth;
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _iways_ui_src_locale__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    t: function t() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _iways_ui_src_locale__WEBPACK_IMPORTED_MODULE_0__[/* t */ "a"].apply(this, args);
    }
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addResizeListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return removeResizeListener; });
/* harmony import */ var resize_observer_polyfill__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(16);
/* harmony import */ var resize_observer_polyfill__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(resize_observer_polyfill__WEBPACK_IMPORTED_MODULE_0__);

var isServer = typeof window === 'undefined';

/* istanbul ignore next */
var resizeHandler = function resizeHandler(entries) {
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var entry = _step.value;

      var listeners = entry.target.__resizeListeners__ || [];
      if (listeners.length) {
        listeners.forEach(function (fn) {
          fn();
        });
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }
};

/* istanbul ignore next */
var addResizeListener = function addResizeListener(element, fn) {
  if (isServer) return;
  if (!element.__resizeListeners__) {
    element.__resizeListeners__ = [];
    element.__ro__ = new resize_observer_polyfill__WEBPACK_IMPORTED_MODULE_0___default.a(resizeHandler);
    element.__ro__.observe(element);
  }
  element.__resizeListeners__.push(fn);
};

/* istanbul ignore next */
var removeResizeListener = function removeResizeListener(element, fn) {
  if (!element || !element.__resizeListeners__) return;
  element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
  if (!element.__resizeListeners__.length) {
    element.__ro__.disconnect();
  }
};

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ popup_manager; });

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(0);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// EXTERNAL MODULE: ./src/utils/merge.js
var merge = __webpack_require__(6);

// EXTERNAL MODULE: ./src/utils/dom.js
var utils_dom = __webpack_require__(1);

// CONCATENATED MODULE: ./src/utils/popup/popup-manager.js



var hasModal = false;
var hasInitZIndex = false;
var popup_manager_zIndex = 2000;

var popup_manager_getModal = function getModal() {
  if (external_vue_default.a.prototype.$isServer) return;
  var modalDom = PopupManager.modalDom;
  if (modalDom) {
    hasModal = true;
  } else {
    hasModal = false;
    modalDom = document.createElement('div');
    PopupManager.modalDom = modalDom;

    modalDom.addEventListener('touchmove', function (event) {
      event.preventDefault();
      event.stopPropagation();
    });

    modalDom.addEventListener('click', function () {
      PopupManager.doOnModalClick && PopupManager.doOnModalClick();
    });
  }

  return modalDom;
};

var instances = {};

var PopupManager = {
  modalFade: true,

  getInstance: function getInstance(id) {
    return instances[id];
  },

  register: function register(id, instance) {
    if (id && instance) {
      instances[id] = instance;
    }
  },

  deregister: function deregister(id) {
    if (id) {
      instances[id] = null;
      delete instances[id];
    }
  },

  nextZIndex: function nextZIndex() {
    return PopupManager.zIndex++;
  },

  modalStack: [],

  doOnModalClick: function doOnModalClick() {
    var topItem = PopupManager.modalStack[PopupManager.modalStack.length - 1];
    if (!topItem) return;

    var instance = PopupManager.getInstance(topItem.id);
    if (instance && instance.closeOnClickModal) {
      instance.close();
    }
  },

  openModal: function openModal(id, zIndex, dom, modalClass, modalFade) {
    if (external_vue_default.a.prototype.$isServer) return;
    if (!id || zIndex === undefined) return;
    this.modalFade = modalFade;

    var modalStack = this.modalStack;

    for (var i = 0, j = modalStack.length; i < j; i++) {
      var item = modalStack[i];
      if (item.id === id) {
        return;
      }
    }

    var modalDom = popup_manager_getModal();

    Object(utils_dom["a" /* addClass */])(modalDom, 'v-modal');
    if (this.modalFade && !hasModal) {
      Object(utils_dom["a" /* addClass */])(modalDom, 'v-modal-enter');
    }
    if (modalClass) {
      var classArr = modalClass.trim().split(/\s+/);
      classArr.forEach(function (item) {
        return Object(utils_dom["a" /* addClass */])(modalDom, item);
      });
    }
    setTimeout(function () {
      Object(utils_dom["g" /* removeClass */])(modalDom, 'v-modal-enter');
    }, 200);

    if (dom && dom.parentNode && dom.parentNode.nodeType !== 11) {
      dom.parentNode.appendChild(modalDom);
    } else {
      document.body.appendChild(modalDom);
    }

    if (zIndex) {
      modalDom.style.zIndex = zIndex;
    }
    modalDom.tabIndex = 0;
    modalDom.style.display = '';

    this.modalStack.push({ id: id, zIndex: zIndex, modalClass: modalClass });
  },

  closeModal: function closeModal(id) {
    var modalStack = this.modalStack;
    var modalDom = popup_manager_getModal();

    if (modalStack.length > 0) {
      var topItem = modalStack[modalStack.length - 1];
      if (topItem.id === id) {
        if (topItem.modalClass) {
          var classArr = topItem.modalClass.trim().split(/\s+/);
          classArr.forEach(function (item) {
            return Object(utils_dom["g" /* removeClass */])(modalDom, item);
          });
        }

        modalStack.pop();
        if (modalStack.length > 0) {
          modalDom.style.zIndex = modalStack[modalStack.length - 1].zIndex;
        }
      } else {
        for (var i = modalStack.length - 1; i >= 0; i--) {
          if (modalStack[i].id === id) {
            modalStack.splice(i, 1);
            break;
          }
        }
      }
    }

    if (modalStack.length === 0) {
      if (this.modalFade) {
        Object(utils_dom["a" /* addClass */])(modalDom, 'v-modal-leave');
      }
      setTimeout(function () {
        if (modalStack.length === 0) {
          if (modalDom.parentNode) modalDom.parentNode.removeChild(modalDom);
          modalDom.style.display = 'none';
          PopupManager.modalDom = undefined;
        }
        Object(utils_dom["g" /* removeClass */])(modalDom, 'v-modal-leave');
      }, 200);
    }
  }
};

Object.defineProperty(PopupManager, 'zIndex', {
  configurable: true,
  get: function get() {
    if (!hasInitZIndex) {
      popup_manager_zIndex = (external_vue_default.a.prototype.$IWAYS || {}).zIndex || popup_manager_zIndex;
      hasInitZIndex = true;
    }
    return popup_manager_zIndex;
  },
  set: function set(value) {
    popup_manager_zIndex = value;
  }
});

var popup_manager_getTopPopup = function getTopPopup() {
  if (external_vue_default.a.prototype.$isServer) return;
  if (PopupManager.modalStack.length > 0) {
    var topPopup = PopupManager.modalStack[PopupManager.modalStack.length - 1];
    if (!topPopup) return;
    var instance = PopupManager.getInstance(topPopup.id);

    return instance;
  }
};

if (!external_vue_default.a.prototype.$isServer) {
  // handle `esc` key when the popup is shown
  window.addEventListener('keydown', function (event) {
    if (event.keyCode === 27) {
      var topPopup = popup_manager_getTopPopup();

      if (topPopup && topPopup.closeOnPressEscape) {
        topPopup.handleClose ? topPopup.handleClose() : topPopup.handleAction ? topPopup.handleAction('cancel') : topPopup.close();
      }
    }
  });
}

/* harmony default export */ var popup_manager = (PopupManager);
// EXTERNAL MODULE: ./src/utils/scrollbar-width.js
var scrollbar_width = __webpack_require__(7);

// CONCATENATED MODULE: ./src/utils/popup/index.js






var idSeed = 1;

var scrollBarWidth = void 0;

/* harmony default export */ var popup = __webpack_exports__["b"] = ({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    openDelay: {},
    closeDelay: {},
    zIndex: {},
    modal: {
      type: Boolean,
      default: false
    },
    modalFade: {
      type: Boolean,
      default: true
    },
    modalClass: {},
    modalAppendToBody: {
      type: Boolean,
      default: false
    },
    lockScroll: {
      type: Boolean,
      default: true
    },
    closeOnPressEscape: {
      type: Boolean,
      default: false
    },
    closeOnClickModal: {
      type: Boolean,
      default: false
    }
  },

  beforeMount: function beforeMount() {
    this._popupId = 'popup-' + idSeed++;
    popup_manager.register(this._popupId, this);
  },
  beforeDestroy: function beforeDestroy() {
    popup_manager.deregister(this._popupId);
    popup_manager.closeModal(this._popupId);

    this.restoreBodyStyle();
  },
  data: function data() {
    return {
      opened: false,
      bodyPaddingRight: null,
      computedBodyPaddingRight: 0,
      withoutHiddenClass: true,
      rendered: false
    };
  },


  watch: {
    visible: function visible(val) {
      var _this = this;

      if (val) {
        if (this._opening) return;
        if (!this.rendered) {
          this.rendered = true;
          external_vue_default.a.nextTick(function () {
            _this.open();
          });
        } else {
          this.open();
        }
      } else {
        this.close();
      }
    }
  },

  methods: {
    open: function open(options) {
      var _this2 = this;

      if (!this.rendered) {
        this.rendered = true;
      }

      var props = Object(merge["a" /* default */])({}, this.$props || this, options);

      if (this._closeTimer) {
        clearTimeout(this._closeTimer);
        this._closeTimer = null;
      }
      clearTimeout(this._openTimer);

      var openDelay = Number(props.openDelay);
      if (openDelay > 0) {
        this._openTimer = setTimeout(function () {
          _this2._openTimer = null;
          _this2.doOpen(props);
        }, openDelay);
      } else {
        this.doOpen(props);
      }
    },
    doOpen: function doOpen(props) {
      if (this.$isServer) return;
      if (this.willOpen && !this.willOpen()) return;
      if (this.opened) return;

      this._opening = true;

      var dom = this.$el;

      var modal = props.modal;

      var zIndex = props.zIndex;
      if (zIndex) {
        popup_manager.zIndex = zIndex;
      }

      if (modal) {
        if (this._closing) {
          popup_manager.closeModal(this._popupId);
          this._closing = false;
        }
        popup_manager.openModal(this._popupId, popup_manager.nextZIndex(), this.modalAppendToBody ? undefined : dom, props.modalClass, props.modalFade);
        if (props.lockScroll) {
          this.withoutHiddenClass = !Object(utils_dom["c" /* hasClass */])(document.body, 'iw-popup-parent--hidden');
          if (this.withoutHiddenClass) {
            this.bodyPaddingRight = document.body.style.paddingRight;
            this.computedBodyPaddingRight = parseInt(Object(utils_dom["b" /* getStyle */])(document.body, 'paddingRight'), 10);
          }
          scrollBarWidth = Object(scrollbar_width["a" /* default */])();
          var bodyHasOverflow = document.documentElement.clientHeight < document.body.scrollHeight;
          var bodyOverflowY = Object(utils_dom["b" /* getStyle */])(document.body, 'overflowY');
          if (scrollBarWidth > 0 && (bodyHasOverflow || bodyOverflowY === 'scroll') && this.withoutHiddenClass) {
            document.body.style.paddingRight = this.computedBodyPaddingRight + scrollBarWidth + 'px';
          }
          Object(utils_dom["a" /* addClass */])(document.body, 'iw-popup-parent--hidden');
        }
      }

      if (getComputedStyle(dom).position === 'static') {
        dom.style.position = 'absolute';
      }

      dom.style.zIndex = popup_manager.nextZIndex();
      this.opened = true;

      this.onOpen && this.onOpen();

      this.doAfterOpen();
    },
    doAfterOpen: function doAfterOpen() {
      this._opening = false;
    },
    close: function close() {
      var _this3 = this;

      if (this.willClose && !this.willClose()) return;

      if (this._openTimer !== null) {
        clearTimeout(this._openTimer);
        this._openTimer = null;
      }
      clearTimeout(this._closeTimer);

      var closeDelay = Number(this.closeDelay);

      if (closeDelay > 0) {
        this._closeTimer = setTimeout(function () {
          _this3._closeTimer = null;
          _this3.doClose();
        }, closeDelay);
      } else {
        this.doClose();
      }
    },
    doClose: function doClose() {
      this._closing = true;

      this.onClose && this.onClose();

      if (this.lockScroll) {
        setTimeout(this.restoreBodyStyle, 200);
      }

      this.opened = false;

      this.doAfterClose();
    },
    doAfterClose: function doAfterClose() {
      popup_manager.closeModal(this._popupId);
      this._closing = false;
    },
    restoreBodyStyle: function restoreBodyStyle() {
      if (this.modal && this.withoutHiddenClass) {
        document.body.style.paddingRight = this.bodyPaddingRight;
        Object(utils_dom["g" /* removeClass */])(document.body, 'iw-popup-parent--hidden');
      }
      this.withoutHiddenClass = true;
    }
  }
});



/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ t; });

// UNUSED EXPORTS: use, i18n

// CONCATENATED MODULE: ./src/locale/lang/zh-CN.js
/* harmony default export */ var zh_CN = ({
  iw: {
    colorpicker: {
      confirm: '确定',
      clear: '清空'
    },
    datepicker: {
      now: '此刻',
      today: '今天',
      cancel: '取消',
      clear: '清空',
      confirm: '确定',
      selectDate: '选择日期',
      selectTime: '选择时间',
      startDate: '开始日期',
      startTime: '开始时间',
      endDate: '结束日期',
      endTime: '结束时间',
      prevYear: '前一年',
      nextYear: '后一年',
      prevMonth: '上个月',
      nextMonth: '下个月',
      year: '年',
      month1: '1 月',
      month2: '2 月',
      month3: '3 月',
      month4: '4 月',
      month5: '5 月',
      month6: '6 月',
      month7: '7 月',
      month8: '8 月',
      month9: '9 月',
      month10: '10 月',
      month11: '11 月',
      month12: '12 月',
      week: '周',
      weeks: {
        sun: '日',
        mon: '一',
        tue: '二',
        wed: '三',
        thu: '四',
        fri: '五',
        sat: '六'
      },
      months: {
        jan: '1月',
        feb: '2月',
        mar: '3月',
        apr: '4月',
        may: '5月',
        jun: '6月',
        jul: '7月',
        aug: '8月',
        sep: '9月',
        oct: '10月',
        nov: '11月',
        dec: '12月'
      },
      quarters: {
        Q1: 'Q1',
        Q2: 'Q2',
        Q3: 'Q3',
        Q4: 'Q4'
      },
      halfYears: {
        H1: 'H1',
        H2: 'H2'
      }
    },
    common: {
      noMatch: '无匹配数据',
      loading: '加载中',
      placeholder: '请选择',
      search: '搜索',
      selected: '已选',
      checkColumnAll: '全选',
      reset: '重置',
      confirm: '确定',
      click: '点击',
      checkAll: '全选所有',
      noData: '暂无数据',
      atLeast: '最少选择{count}项',
      atMost: '最多选择{count}项'
    },
    empty: {
      wait: '等待请求',
      exception: '网络异常',
      unknow: '未知错误'
    },
    select: {
      loading: '加载中',
      noMatch: '无匹配数据',
      noData: '无数据',
      placeholder: '请选择',
      checkAll: '全选'
    },
    manfbrand: {
      quickppositioning: '快速定位'
    },
    submodel: {
      quickppositioning: '快速定位',
      local: '国产',
      import: '进口'
    },
    version: {
      submodel: '车型',
      version: '型号',
      msrp: 'MSRP',
      hot: '热度',
      dataSource: '数据源'
    },
    favorite: {
      subModel: '车型',
      manfBrand: '厂商品牌',
      segment: '细分市场',
      placeholder: '请输入',
      folder: '收藏夹',
      operation: '操作',
      select: '选择',
      del: '删除',
      copy: '复制',
      edit: '编辑',
      confirm: '确定',
      create: '新建',
      cancel: '取消',
      save: '保存',
      saveFirst: '请先保存',
      customFolder: '自定义文件夹',
      maxFolders: '最多不能超过{maxLength}个',
      maxFolderName: '名称不能超过{maxLength}个字',
      nameExist: '名称已重复',
      outOfRange: '超过范围',
      requireModelVersion: '请选择本品车型'
    },
    pagination: {
      goto: '前往',
      pagesize: '条/页',
      total: '共 {total} 条',
      pageClassifier: '页'
    },
    messagebox: {
      title: '提示',
      confirm: '确定',
      cancel: '取消',
      error: '输入的数据不合法!'
    },
    upload: {
      deleteTip: '按 delete 键可删除',
      delete: '删除',
      preview: '查看图片',
      continue: '继续上传'
    },
    table: {
      emptyText: '暂无数据',
      confirmFilter: '筛选',
      resetFilter: '重置',
      clearFilter: '全部',
      sumText: '合计'
    },
    tree: {
      emptyText: '暂无数据'
    },
    transfer: {
      noMatch: '无匹配数据',
      noData: '无数据',
      titles: ['列表 1', '列表 2'],
      filterPlaceholder: '请输入搜索内容',
      noCheckedFormat: '共 {total} 项',
      hasCheckedFormat: '已选 {checked}/{total} 项'
    },
    image: {
      error: '加载失败'
    },
    pageHeader: {
      title: '返回'
    }
  }
});
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(0);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);

// EXTERNAL MODULE: external "deepmerge"
var external_deepmerge_ = __webpack_require__(17);
var external_deepmerge_default = /*#__PURE__*/__webpack_require__.n(external_deepmerge_);

// EXTERNAL MODULE: ./src/utils/util.js
var util = __webpack_require__(3);

// CONCATENATED MODULE: ./src/locale/format.js
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var RE_NARGS = /(%|)\{([0-9a-zA-Z_]+)\}/g;
/**
 *  String format template
 *  - Inspired:
 *    https://github.com/Matt-Esch/string-template/index.js
 */
/* harmony default export */ var format = (function (Vue) {
  /**
   * template
   *
   * @param {String} string
   * @param {Array} ...args
   * @return {String}
   */

  function template(string) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (args.length === 1 && _typeof(args[0]) === 'object') {
      args = args[0];
    }

    if (!args || !args.hasOwnProperty) {
      args = {};
    }

    return string.replace(RE_NARGS, function (match, prefix, i, index) {
      var result = void 0;

      if (string[index - 1] === '{' && string[index + match.length] === '}') {
        return i;
      } else {
        result = Object(util["o" /* hasOwn */])(args, i) ? args[i] : null;
        if (result === null || result === undefined) {
          return '';
        }

        return result;
      }
    });
  }

  return template;
});
// CONCATENATED MODULE: ./src/locale/index.js





var locale_format = format(external_vue_default.a);
var lang = zh_CN;
var merged = false;
var locale_i18nHandler = function i18nHandler() {
  var vuei18n = Object.getPrototypeOf(this || external_vue_default.a).$t;
  if (typeof vuei18n === 'function' && !!external_vue_default.a.locale) {
    if (!merged) {
      merged = true;
      external_vue_default.a.locale(external_vue_default.a.config.lang, external_deepmerge_default()(lang, external_vue_default.a.locale(external_vue_default.a.config.lang) || {}, { clone: true }));
    }
    return vuei18n.apply(this, arguments);
  }
};

var t = function t(path, options) {
  var value = locale_i18nHandler.apply(this, arguments);
  if (value !== null && value !== undefined) return value;

  var array = path.split('.');
  var current = lang;

  for (var i = 0, j = array.length; i < j; i++) {
    var property = array[i];
    value = current[property];
    if (i === j - 1) return locale_format(value, options);
    if (!value) return '';
    current = value;
  }
  return '';
};

var use = function use(l) {
  lang = l || lang;
};

var i18n = function i18n(fn) {
  locale_i18nHandler = fn || locale_i18nHandler;
};

/* harmony default export */ var locale = ({ use: use, t: t, i18n: i18n });

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Show migrating guide in browser console.
 *
 * Usage:
 * import Migrating from '@iways-ui/src/mixins/migrating';
 *
 * mixins: [Migrating]
 *
 * add getMigratingConfig method for your component.
 *  getMigratingConfig() {
 *    return {
 *      props: {
 *        'allow-no-selection': 'allow-no-selection is removed.',
 *        'selection-mode': 'selection-mode is removed.'
 *      },
 *      events: {
 *        selectionchange: 'selectionchange is renamed to selection-change.'
 *      }
 *    };
 *  },
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  mounted: function mounted() {
    if (true) return;
    if (!this.$vnode) return;

    var _getMigratingConfig = this.getMigratingConfig(),
        _getMigratingConfig$p = _getMigratingConfig.props,
        props = _getMigratingConfig$p === undefined ? {} : _getMigratingConfig$p,
        _getMigratingConfig$e = _getMigratingConfig.events,
        events = _getMigratingConfig$e === undefined ? {} : _getMigratingConfig$e;

    var _$vnode = this.$vnode,
        data = _$vnode.data,
        componentOptions = _$vnode.componentOptions;

    var definedProps = data.attrs || {};
    var definedEvents = componentOptions.listeners || {};

    for (var propName in definedProps) {
      if (definedProps.hasOwnProperty(propName) && props[propName]) {
        console.warn('[Migrating][' + this.$options.name + '][Attribute]: ' + props[propName]);
      }
    }

    for (var eventName in definedEvents) {
      if (definedEvents.hasOwnProperty(eventName) && events[eventName]) {
        console.warn('[Migrating][' + this.$options.name + '][Event]: ' + events[eventName]);
      }
    }
  },

  methods: {
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {},
        events: {}
      };
    }
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=template&id=343dd774&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        _vm.type === "textarea" ? "iw-textarea" : "iw-input",
        _vm.inputSize ? "iw-input--" + _vm.inputSize : "",
        {
          "has-error": _vm.hasError,
          "is-disabled": _vm.inputDisabled,
          "iw-input-group": _vm.$slots.prepend || _vm.$slots.append,
          "iw-input-group--append": _vm.$slots.append,
          "iw-input-group--prepend": _vm.$slots.prepend,
          "iw-input--prefix": _vm.$slots.prefix || _vm.prefixIcon,
          "iw-input--suffix":
            _vm.$slots.suffix ||
            _vm.suffixIcon ||
            _vm.clearable ||
            _vm.showPassword
        }
      ],
      on: {
        mouseenter: function($event) {
          _vm.hovering = true
        },
        mouseleave: function($event) {
          _vm.hovering = false
        }
      }
    },
    [
      _vm.type !== "textarea"
        ? [
            _vm.$slots.prepend
              ? _c(
                  "div",
                  { staticClass: "iw-input-group__prepend" },
                  [_vm._t("prepend")],
                  2
                )
              : _vm._e(),
            _vm.type !== "textarea"
              ? _c(
                  "input",
                  _vm._b(
                    {
                      ref: "input",
                      staticClass: "iw-input__inner",
                      attrs: {
                        tabindex: _vm.tabindex,
                        type: _vm.showPassword
                          ? _vm.passwordVisible
                            ? "text"
                            : "password"
                          : _vm.type,
                        disabled: _vm.inputDisabled,
                        readonly: _vm.readonly,
                        autocomplete: _vm.autocomplete,
                        "aria-label": _vm.label
                      },
                      on: {
                        compositionstart: _vm.handleCompositionStart,
                        compositionend: _vm.handleCompositionEnd,
                        input: _vm.handleInput,
                        focus: _vm.handleFocus,
                        blur: _vm.handleBlur,
                        change: _vm.handleChange
                      }
                    },
                    "input",
                    _vm.$attrs,
                    false
                  )
                )
              : _vm._e(),
            _vm.$slots.prefix || _vm.prefixIcon
              ? _c(
                  "span",
                  { staticClass: "iw-input__prefix" },
                  [
                    _vm._t("prefix"),
                    _vm.prefixIcon
                      ? _c("i", {
                          staticClass: "iw-input__icon",
                          class: _vm.prefixIcon
                        })
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e(),
            _vm.$slots.suffix ||
            _vm.suffixIcon ||
            _vm.showClear ||
            _vm.showPassword ||
            (_vm.validateState && _vm.needStatusIcon)
              ? _c("span", { staticClass: "iw-input__suffix" }, [
                  _c(
                    "span",
                    { staticClass: "iw-input__suffix-inner" },
                    [
                      !_vm.showClear || !_vm.showPwdVisible
                        ? [
                            _vm._t("suffix"),
                            _vm.suffixIcon
                              ? _c("i", {
                                  staticClass: "iw-input__icon",
                                  class: _vm.suffixIcon
                                })
                              : _vm._e()
                          ]
                        : _vm._e(),
                      _vm.showClear
                        ? _c("i", {
                            staticClass:
                              "iw-input__icon iw-icon-circle-close iw-input__clear",
                            on: { click: _vm.clear }
                          })
                        : _vm._e(),
                      _vm.showPwdVisible
                        ? _c("i", {
                            staticClass:
                              "iw-input__icon iw-icon-view iw-input__clear",
                            on: { click: _vm.handlePasswordVisible }
                          })
                        : _vm._e()
                    ],
                    2
                  ),
                  _vm.validateState
                    ? _c("i", {
                        staticClass: "iw-input__icon",
                        class: ["iw-input__validateIcon", _vm.validateIcon]
                      })
                    : _vm._e()
                ])
              : _vm._e(),
            _vm.$slots.append
              ? _c(
                  "div",
                  { staticClass: "iw-input-group__append" },
                  [_vm._t("append")],
                  2
                )
              : _vm._e()
          ]
        : _c(
            "textarea",
            _vm._b(
              {
                ref: "textarea",
                staticClass: "iw-textarea__inner",
                style: _vm.textareaStyle,
                attrs: {
                  tabindex: _vm.tabindex,
                  disabled: _vm.inputDisabled,
                  readonly: _vm.readonly,
                  autocomplete: _vm.autocomplete,
                  "aria-label": _vm.label
                },
                on: {
                  compositionstart: _vm.handleCompositionStart,
                  compositionend: _vm.handleCompositionEnd,
                  input: _vm.handleInput,
                  focus: _vm.handleFocus,
                  blur: _vm.handleBlur,
                  change: _vm.handleChange
                }
              },
              "textarea",
              _vm.$attrs,
              false
            )
          )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=template&id=343dd774&

// EXTERNAL MODULE: ./src/mixins/emitter.js
var emitter = __webpack_require__(5);

// EXTERNAL MODULE: ./src/mixins/migrating.js
var migrating = __webpack_require__(12);

// CONCATENATED MODULE: ./packages/input/src/calcTextareaHeight.js
var hiddenTextarea = void 0;

var HIDDEN_STYLE = '\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n';

var CONTEXT_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];

function calculateNodeStyling(targetElement) {
  var style = window.getComputedStyle(targetElement);

  var boxSizing = style.getPropertyValue('box-sizing');

  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));

  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));

  var contextStyle = CONTEXT_STYLE.map(function (name) {
    return name + ':' + style.getPropertyValue(name);
  }).join(';');

  return { contextStyle: contextStyle, paddingSize: paddingSize, borderSize: borderSize, boxSizing: boxSizing };
}

function calcTextareaHeight(targetElement) {
  var minRows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var maxRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    document.body.appendChild(hiddenTextarea);
  }

  var _calculateNodeStyling = calculateNodeStyling(targetElement),
      paddingSize = _calculateNodeStyling.paddingSize,
      borderSize = _calculateNodeStyling.borderSize,
      boxSizing = _calculateNodeStyling.boxSizing,
      contextStyle = _calculateNodeStyling.contextStyle;

  hiddenTextarea.setAttribute('style', contextStyle + ';' + HIDDEN_STYLE);
  hiddenTextarea.value = targetElement.value || targetElement.placeholder || '';

  var height = hiddenTextarea.scrollHeight;
  var result = {};

  if (boxSizing === 'border-box') {
    height = height + borderSize;
  } else if (boxSizing === 'content-box') {
    height = height - paddingSize;
  }

  hiddenTextarea.value = '';
  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;

  if (minRows !== null) {
    var minHeight = singleRowHeight * minRows;
    if (boxSizing === 'border-box') {
      minHeight = minHeight + paddingSize + borderSize;
    }
    height = Math.max(minHeight, height);
    result.minHeight = minHeight + 'px';
  }
  if (maxRows !== null) {
    var maxHeight = singleRowHeight * maxRows;
    if (boxSizing === 'border-box') {
      maxHeight = maxHeight + paddingSize + borderSize;
    }
    height = Math.min(maxHeight, height);
  }
  result.height = height + 'px';
  hiddenTextarea.parentNode && hiddenTextarea.parentNode.removeChild(hiddenTextarea);
  hiddenTextarea = null;
  return result;
}
// EXTERNAL MODULE: ./src/utils/merge.js
var merge = __webpack_require__(6);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/input/src/input.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var inputvue_type_script_lang_js_ = ({
  name: 'IwInput',

  componentName: 'IwInput',

  mixins: [emitter["a" /* default */], migrating["a" /* default */]],

  inheritAttrs: false,

  inject: {
    iwForm: {
      default: ''
    },
    iwFormItem: {
      default: ''
    }
  },

  props: {
    value: {
      type: [String, Number],
      default: function _default() {
        return;
      }
    },
    size: {
      type: String,
      default: ''
    },
    resize: {
      type: String,
      default: function _default() {
        return '';
      }
    },
    form: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'text'
    },
    autosize: {
      type: [Boolean, Object],
      default: false
    },
    autocomplete: {
      type: String,
      default: 'off'
    },
    validateEvent: {
      type: Boolean,
      default: true
    },
    suffixIcon: {
      type: String,
      default: ''
    },
    prefixIcon: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false
    },
    showPassword: {
      type: Boolean,
      default: false
    },
    tabindex: {
      type: String,
      default: ''
    }
  },

  data: function data() {
    return {
      hasError: false,
      textareaCalcStyle: {},
      hovering: false,
      focused: false,
      isComposing: false,
      passwordVisible: false
    };
  },


  computed: {
    _iwFormItemSize: function _iwFormItemSize() {
      return (this.iwFormItem || {}).iwFormItemSize;
    },
    validateState: function validateState() {
      return this.iwFormItem ? this.iwFormItem.validateState : '';
    },
    needStatusIcon: function needStatusIcon() {
      return this.iwForm ? this.iwForm.statusIcon : false;
    },
    validateIcon: function validateIcon() {
      return {
        validating: 'iw-icon-loading',
        success: 'iw-icon-circle-check',
        error: 'iw-icon-circle-close'
      }[this.validateState];
    },
    textareaStyle: function textareaStyle() {
      return Object(merge["a" /* default */])({}, this.textareaCalcStyle, { resize: this.resize });
    },
    inputSize: function inputSize() {
      return this.size || this._iwFormItemSize || (this.$IWAYS || {}).size;
    },
    inputDisabled: function inputDisabled() {
      return this.disabled || (this.iwForm || {}).disabled;
    },
    nativeInputValue: function nativeInputValue() {
      return this.value === null || this.value === undefined ? '' : String(this.value);
    },
    showClear: function showClear() {
      return this.clearable && !this.inputDisabled && !this.readonly && this.nativeInputValue && (this.focused || this.hovering);
    },
    showPwdVisible: function showPwdVisible() {
      return this.showPassword && !this.inputDisabled && !this.readonly && (!!this.nativeInputValue || this.focused);
    }
  },

  watch: {
    value: function value(val) {
      this.$nextTick(this.resizeTextarea);
      if (this.validateEvent) {
        this.dispatch('IwFormItem', 'iw.form.change', [val]);
      }
    },

    // native input value is set explicitly
    // do not use v-model / :value in template
    // see: https://github.com/ElemeFE/element/issues/14521
    nativeInputValue: function nativeInputValue() {
      this.setNativeInputValue();
    },

    // when change between <input> and <textarea>,
    // update DOM dependent value and styles
    // https://github.com/ElemeFE/element/issues/14857
    type: function type() {
      var _this = this;

      this.$nextTick(function () {
        _this.setNativeInputValue();
        _this.resizeTextarea();
        _this.updateIconOffset();
      });
    }
  },

  created: function created() {
    this.$on('inputSelect', this.select);
  },
  mounted: function mounted() {
    this.setNativeInputValue();
    this.resizeTextarea();
    this.updateIconOffset();
  },
  updated: function updated() {
    this.$nextTick(this.updateIconOffset);
  },


  methods: {
    focus: function focus() {
      this.getInput().focus();
    },
    blur: function blur() {
      this.getInput().blur();
    },
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'icon': 'icon is removed, use suffix-icon / prefix-icon instead.',
          'on-icon-click': 'on-icon-click is removed.'
        },
        events: {
          'click': 'click is removed.'
        }
      };
    },
    handleBlur: function handleBlur(event) {
      this.focused = false;
      this.$emit('blur', event);
      if (this.validateEvent) {
        this.dispatch('IwFormItem', 'iw.form.blur', [this.value]);
      }
    },
    select: function select() {
      this.getInput().select();
    },
    resizeTextarea: function resizeTextarea() {
      if (this.$isServer) return;
      var autosize = this.autosize,
          type = this.type;

      if (type !== 'textarea') return;
      if (!autosize) {
        this.textareaCalcStyle = {
          minHeight: calcTextareaHeight(this.$refs.textarea).minHeight
        };
        return;
      }
      var minRows = autosize.minRows;
      var maxRows = autosize.maxRows;

      this.textareaCalcStyle = calcTextareaHeight(this.$refs.textarea, minRows, maxRows);
    },
    setNativeInputValue: function setNativeInputValue() {
      var input = this.getInput();
      if (!input) return;
      if (input.value === this.nativeInputValue) return;
      input.value = this.nativeInputValue;
    },
    handleFocus: function handleFocus(event) {
      this.focused = true;
      this.$emit('focus', event);
    },
    handleCompositionStart: function handleCompositionStart() {
      this.isComposing = true;
    },
    handleCompositionEnd: function handleCompositionEnd(event) {
      this.isComposing = false;
      this.handleInput(event);
    },
    handleInput: function handleInput(event) {
      // should not emit input during composition
      // see: https://github.com/ElemeFE/element/issues/10516
      if (this.isComposing) return;

      // hack for https://github.com/ElemeFE/element/issues/8548
      // should remove the following line when we don't support IE
      if (event.target.value === this.nativeInputValue) return;

      this.$emit('input', event.target.value);

      // ensure native input value is controlled
      // see: https://github.com/ElemeFE/element/issues/12850
      this.$nextTick(this.setNativeInputValue);
    },
    handleChange: function handleChange(event) {
      this.$emit('change', event.target.value);
    },
    calcIconOffset: function calcIconOffset(place) {
      var elList = [].slice.call(document.querySelectorAll('.iw-input__' + place) || []);
      if (!elList.length) return;
      var iw = null;
      for (var i = 0; i < elList.length; i++) {
        if (elList[i].parentNode === this.$iw) {
          iw = elList[i];
          break;
        }
      }
      if (!iw) return;
      var pendantMap = {
        suffix: 'append',
        prefix: 'prepend'
      };

      var pendant = pendantMap[place];
      if (this.$slots[pendant]) {
        iw.style.transform = 'translateX(' + (place === 'suffix' ? '-' : '') + this.$iw.querySelector('.iw-input-group__' + pendant).offsetWidth + 'px)';
      } else {
        iw.removeAttribute('style');
      }
    },
    updateIconOffset: function updateIconOffset() {
      this.calcIconOffset('prefix');
      this.calcIconOffset('suffix');
    },
    clear: function clear() {
      this.$emit('input', '');
      this.$emit('change', '');
      this.$emit('clear');
    },
    handlePasswordVisible: function handlePasswordVisible() {
      this.passwordVisible = !this.passwordVisible;
      this.focus();
    },
    getInput: function getInput() {
      return this.$refs.input || this.$refs.textarea;
    },
    setError: function setError() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.hasError = error;
    }
  }
});
// CONCATENATED MODULE: ./packages/input/src/input.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_inputvue_type_script_lang_js_ = (inputvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(2);

// CONCATENATED MODULE: ./packages/input/src/input.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_inputvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/input/src/input.vue"
/* harmony default export */ var input = (component.exports);
// CONCATENATED MODULE: ./packages/input/index.js


/* istanbul ignore next */
input.install = function (Vue) {
  Vue.component(input.name, input);
};

/* harmony default export */ var packages_input = __webpack_exports__["default"] = (input);

/***/ }),
/* 14 */,
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=template&id=ca859fb4&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "iw-button",
      class: [
        _vm.type ? "iw-button--" + _vm.type : "",
        _vm.buttonSize ? "iw-button--" + _vm.buttonSize : "",
        {
          "is-disabled": _vm.buttonDisabled,
          "is-loading": _vm.loading,
          "is-plain": _vm.plain,
          "is-round": _vm.round,
          "is-circle": _vm.circle
        }
      ],
      attrs: {
        disabled: _vm.buttonDisabled || _vm.loading,
        autofocus: _vm.autofocus,
        type: _vm.nativeType
      },
      on: { click: _vm.handleClick }
    },
    [
      _vm.loading ? _c("i", { staticClass: "iw-icon-loading" }) : _vm._e(),
      _vm.icon && !_vm.loading ? _c("i", { class: _vm.icon }) : _vm._e(),
      _vm.$slots.default ? _c("span", [_vm._t("default")], 2) : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=template&id=ca859fb4&

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/button/src/button.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var buttonvue_type_script_lang_js_ = ({
  name: 'IwButton',

  inject: {
    iwForm: {
      default: ''
    },
    iwFormItem: {
      default: ''
    }
  },

  props: {
    type: {
      type: String,
      default: 'default'
    },
    size: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    nativeType: {
      type: String,
      default: 'button'
    },
    loading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    plain: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    round: {
      type: Boolean,
      default: false
    },
    circle: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    _iwFormItemSize: function _iwFormItemSize() {
      return (this.iwFormItem || {}).iwFormItemSize;
    },
    buttonSize: function buttonSize() {
      return this.size || (this.$IWAYS || {}).size;
    },
    buttonDisabled: function buttonDisabled() {
      return this.disabled;
    }
  },

  methods: {
    handleClick: function handleClick(evt) {
      this.$emit('click', evt);
    }
  }
});
// CONCATENATED MODULE: ./packages/button/src/button.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_buttonvue_type_script_lang_js_ = (buttonvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(2);

// CONCATENATED MODULE: ./packages/button/src/button.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_buttonvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/button/src/button.vue"
/* harmony default export */ var src_button = (component.exports);
// CONCATENATED MODULE: ./packages/button/index.js


/* istanbul ignore next */
src_button.install = function (Vue) {
  Vue.component(src_button.name, src_button);
};

/* harmony default export */ var packages_button = __webpack_exports__["default"] = (src_button);

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports = require("resize-observer-polyfill");

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = require("deepmerge");

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: ./src/utils/resize-event.js
var resize_event = __webpack_require__(9);

// EXTERNAL MODULE: ./src/utils/scrollbar-width.js
var scrollbar_width = __webpack_require__(7);

// EXTERNAL MODULE: ./src/utils/util.js
var util = __webpack_require__(3);

// EXTERNAL MODULE: ./src/utils/dom.js
var dom = __webpack_require__(1);

// CONCATENATED MODULE: ./packages/scrollbar/src/util.js
var BAR_MAP = {
  vertical: {
    offset: 'offsetHeight',
    scroll: 'scrollTop',
    scrollSize: 'scrollHeight',
    size: 'height',
    key: 'vertical',
    axis: 'Y',
    client: 'clientY',
    direction: 'top'
  },
  horizontal: {
    offset: 'offsetWidth',
    scroll: 'scrollLeft',
    scrollSize: 'scrollWidth',
    size: 'width',
    key: 'horizontal',
    axis: 'X',
    client: 'clientX',
    direction: 'left'
  }
};

function renderThumbStyle(_ref) {
  var move = _ref.move,
      size = _ref.size,
      bar = _ref.bar;

  var style = {};
  var translate = 'translate' + bar.axis + '(' + move + '%)';

  style[bar.size] = size;
  style.transform = translate;
  style.msTransform = translate;
  style.webkitTransform = translate;

  return style;
}
// CONCATENATED MODULE: ./packages/scrollbar/src/bar.js



/* istanbul ignore next */
/* harmony default export */ var src_bar = ({
  name: 'Bar',

  props: {
    vertical: Boolean,
    size: String,
    move: Number,
    keepShow: Boolean
  },

  computed: {
    bar: function bar() {
      return BAR_MAP[this.vertical ? 'vertical' : 'horizontal'];
    },
    wrap: function wrap() {
      return this.$parent.wrap;
    }
  },

  render: function render(h) {
    var size = this.size,
        move = this.move,
        bar = this.bar;


    return h(
      'div',
      {
        'class': ['iw-scrollbar__bar', 'is-' + bar.key],
        style: this.keepShow ? 'opacity: 1' : '',
        on: {
          'mousedown': this.clickTrackHandler
        }
      },
      [h('div', {
        ref: 'thumb',
        'class': 'iw-scrollbar__thumb',
        on: {
          'mousedown': this.clickThumbHandler
        },

        style: renderThumbStyle({ size: size, move: move, bar: bar }) })]
    );
  },


  methods: {
    clickThumbHandler: function clickThumbHandler(e) {
      // prevent click event of right button
      if (e.ctrlKey || e.button === 2) {
        return;
      }
      this.startDrag(e);
      this[this.bar.axis] = e.currentTarget[this.bar.offset] - (e[this.bar.client] - e.currentTarget.getBoundingClientRect()[this.bar.direction]);
    },
    clickTrackHandler: function clickTrackHandler(e) {
      var offset = Math.abs(e.target.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]);
      var thumbHalf = this.$refs.thumb[this.bar.offset] / 2;
      var thumbPositionPercentage = (offset - thumbHalf) * 100 / this.$el[this.bar.offset];

      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
    },
    startDrag: function startDrag(e) {
      e.stopImmediatePropagation();
      this.cursorDown = true;

      Object(dom["e" /* on */])(document, 'mousemove', this.mouseMoveDocumentHandler);
      Object(dom["e" /* on */])(document, 'mouseup', this.mouseUpDocumentHandler);
      document.onselectstart = function () {
        return false;
      };
    },
    mouseMoveDocumentHandler: function mouseMoveDocumentHandler(e) {
      if (this.cursorDown === false) return;
      var prevPage = this[this.bar.axis];

      if (!prevPage) return;

      var offset = (this.$el.getBoundingClientRect()[this.bar.direction] - e[this.bar.client]) * -1;
      var thumbClickPosition = this.$refs.thumb[this.bar.offset] - prevPage;
      var thumbPositionPercentage = (offset - thumbClickPosition) * 100 / this.$el[this.bar.offset];

      this.wrap[this.bar.scroll] = thumbPositionPercentage * this.wrap[this.bar.scrollSize] / 100;
    },
    mouseUpDocumentHandler: function mouseUpDocumentHandler(e) {
      this.cursorDown = false;
      this[this.bar.axis] = 0;
      Object(dom["d" /* off */])(document, 'mousemove', this.mouseMoveDocumentHandler);
      document.onselectstart = null;
    }
  },

  destroyed: function destroyed() {
    Object(dom["d" /* off */])(document, 'mouseup', this.mouseUpDocumentHandler);
  }
});
// CONCATENATED MODULE: ./packages/scrollbar/src/main.js
// reference https://github.com/noeldelgado/gemini-scrollbar/blob/master/index.js






/* istanbul ignore next */
/* harmony default export */ var main = ({
  name: 'IwScrollbar',

  components: { Bar: src_bar },

  props: {
    native: Boolean,
    keepShow: Boolean,
    wrapStyle: {},
    wrapClass: {},
    viewClass: {},
    viewStyle: {},
    noresize: Boolean, // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
    tag: {
      type: String,
      default: 'div'
    }
  },

  data: function data() {
    return {
      sizeWidth: '0',
      sizeHeight: '0',
      moveX: 0,
      moveY: 0
    };
  },


  computed: {
    wrap: function wrap() {
      return this.$refs.wrap;
    }
  },

  render: function render(h) {
    var gutter = Object(scrollbar_width["a" /* default */])();
    var style = this.wrapStyle;

    if (gutter) {
      var gutterWith = '-' + gutter + 'px';
      var gutterStyle = 'margin-bottom: ' + gutterWith + '; margin-right: ' + gutterWith + ';';

      if (Array.isArray(this.wrapStyle)) {
        style = Object(util["s" /* toObject */])(this.wrapStyle);
        style.marginRight = style.marginBottom = gutterWith;
      } else if (typeof this.wrapStyle === 'string') {
        style += gutterStyle;
      } else {
        style = gutterStyle;
      }
    }
    var view = h(this.tag, {
      class: ['iw-scrollbar__view', this.viewClass],
      style: this.viewStyle,
      ref: 'resize'
    }, this.$slots.default);
    var wrap = h(
      'div',
      {
        ref: 'wrap',
        style: style,
        on: {
          'scroll': this.handleScroll
        },

        'class': [this.wrapClass, 'iw-scrollbar__wrap', gutter ? '' : 'iw-scrollbar__wrap--hidden-default'] },
      [[view]]
    );
    var nodes = void 0;

    if (!this.native) {
      nodes = [wrap, h(src_bar, {
        attrs: {
          move: this.moveX,
          keepShow: this.keepShow,
          size: this.sizeWidth }
      }), h(src_bar, {
        attrs: {
          vertical: true,
          move: this.moveY,
          keepShow: this.keepShow,
          size: this.sizeHeight }
      })];
    } else {
      nodes = [h(
        'div',
        {
          ref: 'wrap',
          'class': [this.wrapClass, 'iw-scrollbar__wrap'],
          style: style },
        [[view]]
      )];
    }
    return h('div', { class: 'iw-scrollbar' }, nodes);
  },


  methods: {
    handleScroll: function handleScroll() {
      var wrap = this.wrap;

      this.moveY = wrap.scrollTop * 100 / wrap.clientHeight;
      this.moveX = wrap.scrollLeft * 100 / wrap.clientWidth;

      this.$emit('scroll', { scrollTop: wrap.scrollTop, scrollLeft: wrap.scrollLeft });
    },
    update: function update() {
      var wrap = this.wrap;
      if (!wrap) return;

      var heightPercentage = wrap.clientHeight * 100 / wrap.scrollHeight;
      var widthPercentage = wrap.clientWidth * 100 / wrap.scrollWidth;

      this.sizeHeight = heightPercentage < 100 ? heightPercentage + '%' : '';
      this.sizeWidth = widthPercentage < 100 ? widthPercentage + '%' : '';
    }
  },

  mounted: function mounted() {
    if (this.native) return;
    this.$nextTick(this.update);
    !this.noresize && Object(resize_event["a" /* addResizeListener */])(this.$refs.resize, this.update);
  },
  beforeDestroy: function beforeDestroy() {
    if (this.native) return;
    !this.noresize && Object(resize_event["b" /* removeResizeListener */])(this.$refs.resize, this.update);
  }
});
// CONCATENATED MODULE: ./packages/scrollbar/index.js


/* istanbul ignore next */
main.install = function (Vue) {
  Vue.component(main.name, main);
};

/* harmony default export */ var scrollbar = __webpack_exports__["default"] = (main);

/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/popover.vue?vue&type=template&id=7d45d87c&
var render = function() {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "popover", staticClass: "iw-popover__wrap" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.disabled && _vm.visible,
            expression: "!disabled&&visible"
          }
        ],
        ref: "contentWrapper",
        staticClass: "iw-popover",
        class:
          ((_obj = {}),
          (_obj["iw-placement-" + _vm.currentPlacement.split("-")[0]] = true),
          (_obj[_vm.popperClass] = true),
          _obj),
        style: {
          width: _vm.width > 0 ? _vm.width + "px" : "auto",
          zIndex: _vm.zIndex,
          background: _vm.bodyStyle.background,
          borderColor: _vm.bodyStyle.background
        },
        attrs: { id: _vm.tooltipId }
      },
      [
        _c(
          "div",
          { staticClass: "iw-popover__content", style: _vm.bodyStyle },
          [_vm._t("default", [_vm._v(_vm._s(_vm.content))])],
          2
        ),
        _vm.showArrow
          ? _c("div", { ref: "arrow", staticClass: "iw-popover__arrow" })
          : _vm._e()
      ]
    ),
    _c("div", { ref: "triggerWrapper" }, [_vm._t("reference")], 2)
  ])
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/popover/src/popover.vue?vue&type=template&id=7d45d87c&

// EXTERNAL MODULE: ./src/utils/util.js
var util = __webpack_require__(3);

// EXTERNAL MODULE: ./src/utils/dom.js
var dom = __webpack_require__(1);

// EXTERNAL MODULE: ./src/utils/popup/index.js + 1 modules
var popup = __webpack_require__(10);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/popover/src/popover.vue?vue&type=script&lang=js&
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var positions = ['top', 'bottom', 'left', 'right', 'top-start', 'top-end', 'bottom-start', 'bottom-end', 'left-start', 'left-end', 'right-start', 'right-end', 'topLeft', 'topRight', 'bottomLeft', 'bottomRight', 'leftTop', 'leftBottom', 'rightTop', 'rightBottom'];
var stop = function stop(e) {
  return e.stopPropagation();
};
/* harmony default export */ var popovervue_type_script_lang_js_ = ({
  name: 'IwPopover',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      validator: function validator(value) {
        return positions.indexOf(value) >= 0 || value === undefined || value === '';
      }
    },
    trigger: {
      type: String,
      default: 'click',
      validator: function validator(value) {
        return ['click', 'hover'].indexOf(value) >= 0;
      }
    },
    content: {
      type: String,
      default: ''
    },
    reference: {
      type: Object,
      default: function _default() {
        return undefined;
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    popperClass: {
      type: String,
      default: ''
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '0'
    },
    transition: {
      type: String,
      default: 'fade-in-linear'
    },
    showArrow: {
      type: Boolean,
      default: false
    },
    bodyStyle: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    offset: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      visible: false,
      zIndex: 2000,
      referenceElm: undefined,
      popperElm: undefined,
      currentPlacement: ''
    };
  },

  computed: {
    tooltipId: function tooltipId() {
      return 'iw-popover-' + Object(util["k" /* generateId */])();
    }
  },
  watch: {
    value: function value() {
      var _this = this;

      setTimeout(function () {
        _this.visible = _this.value;
        if (_this.value) {
          _this.open();
        } else {
          _this.close();
        }
      });
    },
    visible: function visible() {
      this.zIndex = popup["a" /* PopupManager */].nextZIndex();
    }
  },
  mounted: function mounted() {
    var reference = this.referenceElm = this.reference || this.$refs.triggerWrapper;
    if (!reference && this.$slots.reference && this.$slots.reference[0]) {
      reference = this.referenceElm = this.$slots.reference[0].elm;
    }
    if (reference) {
      Object(dom["a" /* addClass */])(reference, 'iw-popover__reference');
      reference.setAttribute('aria-describedby', this.tooltipId);
      reference.setAttribute('tabindex', 0);
    }

    this.currentPlacement = this.currentPlacement || this.placement;
    this.currentPlacement = this.convertPlacement(this.currentPlacement);
    if (this.trigger === 'click') {
      this.$refs.popover.addEventListener('click', this.onClick);
    } else {
      this.$refs.popover.addEventListener('mouseenter', this.open);
      this.$refs.popover.addEventListener('mouseleave', this.close);
      this.$refs.contentWrapper.addEventListener('mouseenter', this.open);
      this.$refs.contentWrapper.addEventListener('mouseleave', this.close);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.popperElm && this.popperElm.parentNode === document.body) {
      this.popperElm.removeEventListener('click', stop);
      document.body.removeChild(this.popperElm);
    }
  },
  destroyed: function destroyed() {
    if (this.trigger === 'click') {
      this.$refs.popover && this.$refs.popover.removeEventListener('click', this.onClick);
    } else {
      this.$refs.popover && this.$refs.popover.removeEventListener('mouseenter', this.open);
      this.$refs.popover && this.$refs.popover.removeEventListener('mouseleave', this.close);
      this.$refs.contentWrapper && this.$refs.contentWrapper.removeEventListener('mouseenter', this.open);
      this.$refs.contentWrapper && this.$refs.contentWrapper.removeEventListener('mouseleave', this.close);
    }
  },


  methods: {
    convertPlacement: function convertPlacement(placement) {
      placement = placement.replace('Left', '-start');
      placement = placement.replace('Top', '-start');
      placement = placement.replace('Right', '-end');
      placement = placement.replace('Bottom', '-end');
      return placement;
    },
    positionContent: function positionContent() {
      this.popperElm = this.popperElm || this.$refs.contentWrapper;
      if (this.appendToBody) document.body.appendChild(this.popperElm);

      var _referenceElm$getBoun = this.referenceElm.getBoundingClientRect(),
          width = _referenceElm$getBoun.width,
          height = _referenceElm$getBoun.height,
          left = _referenceElm$getBoun.left,
          top = _referenceElm$getBoun.top;

      var _popperElm$getBoundin = this.popperElm.getBoundingClientRect(),
          popperHeight = _popperElm$getBoundin.height,
          popperWidth = _popperElm$getBoundin.width;

      var windowScrollX = window.scrollX || window.pageXOffset;
      var windowScrollY = window.scrollY || window.pageYOffset;
      var windowHeight = window.innerHeight;
      var windowWidth = window.innerWidth;
      /* 获取初始placement */
      this.currentPlacement = this.convertPlacement(this.placement);
      /**
       * 判断出 top bottom left right 四个主要方向
       * 并且当出现遮挡的时候自动修正方向
      */
      var placementArr = ['bottom', 'top', 'right', 'left'];
      var placement = this.currentPlacement.split('-')[0];
      placement = placementArr.includes(placement) ? placement : '';
      if (placement) placementArr.unshift(placement);
      placementArr = [].concat(_toConsumableArray(new Set(placementArr)));

      var modifyArr = ['start', 'end'];
      var modify = this.currentPlacement.split('-')[1] || '';
      modify = modifyArr.includes(modify) ? modify : placement ? 'center' : '';
      if (modify) modifyArr.unshift(modify);
      modifyArr = [].concat(_toConsumableArray(new Set(modifyArr)));

      var _placement = placementArr.find(function (_placement) {
        switch (_placement) {
          case 'bottom':
            if (windowHeight > top + height + popperHeight) return true;
            break;
          case 'top':
            if (top > popperHeight) return true;
            break;
          case 'right':
            // 宽度和高度足够
            if (windowWidth > left + width + popperWidth && windowHeight > popperHeight) return true;
            break;
          case 'left':
            // 宽度和高度足够
            if (left > popperWidth && windowHeight > popperHeight) return true;
            break;
        }
      }) || 'bottom';
      var _currentPlacement = [_placement];

      /* placement为空时，默认左对齐 */
      if (!placement) modify = 'start';
      /* 存在初始对齐方式时，重置对齐方式 */

      var _modify = modifyArr.find(function (type) {
        switch (type) {
          case 'center':
            if (['top', 'bottom'].includes(_placement)) {
              if (left + (width + popperWidth) / 2 < windowWidth && left + (width - popperWidth) / 2 > 0) return true;
            }
            if (['left', 'right'].includes(_placement)) {
              if (top + (height + popperHeight) / 2 < windowHeight && top + (height - popperHeight) / 2 > 0) return true;
            }
            break;
          case 'start':
            if (['top', 'bottom'].includes(_placement)) {
              if (left + popperWidth < windowWidth) return true;
            }
            if (['left', 'right'].includes(_placement)) {
              if (top + popperHeight < windowHeight) return true;
            }
            break;
          case 'end':
            if (['top', 'bottom'].includes(_placement)) {
              if (left + width > popperWidth) return true;
            }
            if (['left', 'right'].includes(_placement)) {
              if (top + height > popperHeight) return true;
            }
            break;
        }
      }) || '';
      /* 对齐方式合理时，重置对齐方式，不合理时，不设置对齐方式 */
      if (_modify && _modify !== 'center') _currentPlacement.push(_modify);

      _currentPlacement = _currentPlacement.join('-');
      /* 重置currentPlacement */
      this.currentPlacement = _currentPlacement;

      /* 相对reference居中时popper左边的距离 */
      var leftReferenceCenter = left - (popperWidth - width) / 2;
      /* 相对窗口居中时popper左边的距离 */
      var windowCenter = (windowWidth - popperWidth) / 2;

      var positionValue = {
        'top': {
          top: top + windowScrollY,
          left: (leftReferenceCenter + popperWidth < windowWidth && leftReferenceCenter > 0 ? leftReferenceCenter : windowCenter) + windowScrollX + (this.offset.left || 0)
        },
        'top-start': {
          top: top + windowScrollY,
          left: left + windowScrollX + (this.offset.left || 0)
        },
        'top-end': {
          top: top + windowScrollY,
          left: left + width - popperWidth + windowScrollX + (this.offset.left || 0)
        },
        'bottom': {
          top: top + height + windowScrollY,
          left: (leftReferenceCenter + popperWidth < windowWidth && leftReferenceCenter > 0 ? leftReferenceCenter : windowCenter) + windowScrollX + (this.offset.left || 0)
        },
        'bottom-start': {
          top: top + height + windowScrollY,
          left: left + windowScrollX + (this.offset.left || 0)
        },
        'bottom-end': {
          top: top + height + windowScrollY,
          left: left + width - popperWidth + windowScrollX + (this.offset.left || 0)
        },
        'left': {
          top: top + (height - popperHeight) / 2 + windowScrollY + (this.offset.top || 0),
          left: left + windowScrollX
        },
        'left-start': {
          top: top + windowScrollY + (this.offset.top || 0),
          left: left + windowScrollX
        },
        'left-end': {
          top: top + height - popperHeight + windowScrollY + (this.offset.top || 0),
          left: left + windowScrollX
        },
        'right': {
          top: top + (height - popperHeight) / 2 + windowScrollY + (this.offset.top || 0),
          left: left + width + windowScrollX
        },
        'right-start': {
          top: top + windowScrollY + (this.offset.top || 0),
          left: left + width + windowScrollX
        },
        'right-end': {
          top: top + height - popperHeight + windowScrollY + (this.offset.top || 0),
          left: left + width + windowScrollX
        }
      };

      if (!this.appendToBody) {
        var _$el = this.$el,
            offsetLeft = _$el.offsetLeft,
            offsetTop = _$el.offsetTop,
            offsetHeight = _$el.offsetHeight,
            offsetWidth = _$el.offsetWidth;

        var _$el$getBoundingClien = this.$el.getBoundingClientRect(),
            _left = _$el$getBoundingClien.left;

        var _document$body$getBou = document.body.getBoundingClientRect(),
            parentWidth = _document$body$getBou.width;

        var offLeftReferenceCenter = offsetLeft - (popperWidth - width) / 2;
        var parentCenter = (parentWidth - popperWidth) / 2;
        positionValue = {
          'top': {
            top: offsetTop,
            left: offLeftReferenceCenter + popperWidth < parentWidth && offLeftReferenceCenter > 0 ? offLeftReferenceCenter : parentCenter
          },
          'top-start': {
            top: offsetTop,
            left: offsetLeft
          },
          'top-end': {
            top: offsetTop,
            left: offsetLeft - popperWidth + width
          },
          'bottom': {
            top: offsetHeight + offsetTop,
            left: offLeftReferenceCenter + popperWidth < parentWidth && offLeftReferenceCenter > 0 ? offLeftReferenceCenter : parentCenter
          },
          'bottom-start': {
            top: offsetHeight + offsetTop,
            left: offsetLeft
          },
          'bottom-end': {
            top: offsetHeight + offsetTop,
            left: offsetLeft - popperWidth + width
          },
          'left': {
            top: offsetTop + (offsetHeight - popperHeight) / 2,
            left: offsetLeft
          },
          'left-start': {
            top: offsetTop,
            left: offsetLeft
          },
          'left-end': {
            top: offsetTop + (offsetHeight - popperHeight),
            left: offsetLeft
          },
          'right': {
            top: offsetTop + (offsetHeight - popperHeight) / 2,
            left: offsetLeft + offsetWidth
          },
          'right-start': {
            top: offsetTop,
            left: offsetLeft + offsetWidth
          },
          'right-end': {
            top: offsetTop + (offsetHeight - popperHeight),
            left: offsetLeft + offsetWidth
          }
        };
      }
      // this.popperElm.style.left = positionValue[_currentPlacement].left < 0 ? 0 : positionValue[_currentPlacement].left + 'px'
      // this.popperElm.style.top = positionValue[_currentPlacement].top < 0 ? 0 : positionValue[_currentPlacement].top + 'px'
      this.popperElm.style.left = positionValue[_currentPlacement].left + 'px';
      this.popperElm.style.top = positionValue[_currentPlacement].top + 'px';
      var arrowWidthHeight = 12;
      if (this.showArrow) {
        var _$el2 = this.$el,
            _offsetLeft = _$el2.offsetLeft,
            _offsetTop = _$el2.offsetTop,
            _offsetHeight = _$el2.offsetHeight,
            _offsetWidth = _$el2.offsetWidth;

        if (['top', 'bottom'].includes(_currentPlacement)) {
          this.$refs.arrow.style.left = (popperWidth - arrowWidthHeight) / 2 + 'px';
          this.$refs.arrow.style.top = -arrowWidthHeight + 'px';
        }
        if (['top-start', 'bottom-start'].includes(_currentPlacement)) {
          this.$refs.arrow.style.left = (width - arrowWidthHeight) / 2 + 'px';
        }
        if (['top-end', 'bottom-end'].includes(_currentPlacement)) {
          this.$refs.arrow.style.left = popperWidth - (width + arrowWidthHeight) / 2 + 'px';
        }
        if (['left', 'right'].includes(_currentPlacement)) {
          this.$refs.arrow.style.top = (popperHeight - arrowWidthHeight) / 2 - (this.offset.top || 0) + 'px';
        }
        if (['left-start', 'right-start'].includes(_currentPlacement)) {
          this.$refs.arrow.style.top = arrowWidthHeight / 2 - (this.offset.top || 0) + 'px';
        }
        if (['left-end', 'right-end'].includes(_currentPlacement)) {
          this.$refs.arrow.style.top = popperHeight - (height + arrowWidthHeight) / 2 - (this.offset.top || 0) + 'px';
        }
        if (['top', 'top-end', 'top-start'].includes(_currentPlacement)) {
          this.$refs.arrow.style.top = popperHeight - 1 + 'px';
          this.$refs.arrow.style.borderTopColor = this.bodyStyle.background || '#fff';
        }
        if (['bottom', 'bottom-end', 'bottom-start'].includes(_currentPlacement)) {
          this.$refs.arrow.style.top = -arrowWidthHeight + 'px';
          this.$refs.arrow.style.borderBottomColor = this.bodyStyle.background || '#fff';
        }
        if (['left', 'left-start', 'left-end'].includes(_currentPlacement)) {
          this.$refs.arrow.style.left = popperWidth - 1 + 'px';
          this.$refs.arrow.style.borderLeftColor = this.bodyStyle.background || '#fff';
        }
        if (['right', 'right-start', 'right-end'].includes(_currentPlacement)) {
          this.$refs.arrow.style.left = -arrowWidthHeight + 'px';
          this.$refs.arrow.style.borderRightColor = this.bodyStyle.background || '#fff';
        }
      } else {
        this.popperElm.style.marginLeft = 0;
        this.popperElm.style.marginTop = 0;
      }
    },
    onClickDocument: function onClickDocument(e) {
      if (this.$refs.popover && (this.$refs.popover === e.target || this.$refs.popover.contains(e.target))) {
        return;
      }
      if (this.$refs.contentWrapper && (this.$refs.contentWrapper === e.target || this.$refs.contentWrapper.contains(e.target))) {
        return;
      }
      this.close();
    },
    listenToDocument: function listenToDocument() {
      document.addEventListener('click', this.onClickDocument);
    },
    open: function open() {
      var _this2 = this;

      this.visible = true;
      this.$emit('input', this.visible);
      this.$nextTick(function () {
        _this2.positionContent();
        _this2.listenToDocument();
      });
    },
    close: function close() {
      this.visible = false;
      this.$emit('input', this.visible);
      document.removeEventListener('click', this.onClickDocument);
    },
    onClick: function onClick(event) {
      if (this.$refs.triggerWrapper && this.$refs.triggerWrapper.contains(event.target)) {
        if (this.visible === true) {
          this.close();
        } else {
          this.open();
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./packages/popover/src/popover.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_popovervue_type_script_lang_js_ = (popovervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(2);

// CONCATENATED MODULE: ./packages/popover/src/popover.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_popovervue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/popover/src/popover.vue"
/* harmony default export */ var popover = (component.exports);
// CONCATENATED MODULE: ./packages/popover/index.js


/* istanbul ignore next */
popover.install = function (Vue) {
  Vue.component(popover.name, popover);
};

/* harmony default export */ var packages_popover = __webpack_exports__["default"] = (popover);

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/empty/src/empty.vue?vue&type=template&id=0ffb948c&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "iw-empty" }, [
    _c("div", { class: "iw-empty--" + _vm.size }, [
      _c("div", { staticClass: "iw-empty__main" }, [
        _c(
          "span",
          [_vm._t("icon", [_c("i", { staticClass: "iw-icon-warning" })])],
          2
        ),
        _c(
          "p",
          [
            _vm._t("tips", [
              _vm._v("\n          " + _vm._s(_vm.tips) + "\n        ")
            ])
          ],
          2
        )
      ])
    ]),
    false ? undefined : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/empty/src/empty.vue?vue&type=template&id=0ffb948c&

// EXTERNAL MODULE: ./src/mixins/locale.js
var locale = __webpack_require__(8);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/empty/src/empty.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var emptyvue_type_script_lang_js_ = ({
  name: 'IwEmpty',
  mixins: [locale["a" /* default */]],
  props: {
    size: {
      type: String,
      default: 'default'
    },
    status: {
      type: [String, Number],
      default: undefined
    }
  },
  computed: {
    tips: function tips() {
      var tips = '';
      if (typeof this.status === 'string') {
        return this.status;
      }
      switch (parseInt(this.status)) {
        case 0:
          tips = this.t('iw.empty.wait');
          break;
        case 500:
          tips = this.t('iw.empty.exception');
          break;
        case 200:
          tips = this.t('iw.common.noData');
          break;
        default:
          tips = this.t('iw.empty.unknow');
          break;
      }
      return tips;
    }
  }
});
// CONCATENATED MODULE: ./packages/empty/src/empty.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_emptyvue_type_script_lang_js_ = (emptyvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(2);

// CONCATENATED MODULE: ./packages/empty/src/empty.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_emptyvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/empty/src/empty.vue"
/* harmony default export */ var empty = (component.exports);
// CONCATENATED MODULE: ./packages/empty/index.js


/* istanbul ignore next */
empty.install = function (Vue) {
  Vue.component(empty.name, empty);
};

/* harmony default export */ var packages_empty = __webpack_exports__["default"] = (empty);

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/tag/src/tag.vue?vue&type=script&lang=js&

/* harmony default export */ var tagvue_type_script_lang_js_ = ({
  name: 'IwTag',
  props: {
    text: {
      type: String,
      default: ''
    },
    closable: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: ''
    },
    hit: {
      type: Boolean,
      default: false
    },
    disableTransitions: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    }
  },
  computed: {
    tagSize: function tagSize() {
      return this.size || (this.$IWAYS || {}).size;
    }
  },
  methods: {
    handleClose: function handleClose(event) {
      event.stopPropagation();
      this.$emit('close', event);
    },
    handleClick: function handleClick(event) {
      event.stopPropagation();
      this.$emit('click', event);
    }
  },
  render: function render(h) {
    var classes = ['iw-tag', this.type ? 'iw-tag--' + this.type : '', this.tagSize ? 'iw-tag--' + this.tagSize : '', { 'is-hit': this.hit }];
    var tagEl = h(
      'span',
      { 'class': classes, style: { backgroundColor: this.color }, on: {
          'click': this.handleClick
        }
      },
      [this.$slots.default, this.closable && h('i', { 'class': 'iw-tag__close iw-icon-close', on: {
          'click': this.handleClose
        }
      })]
    );

    return this.disableTransitions ? tagEl : h(
      'transition',
      {
        attrs: { name: 'iw-zoom-in-center' }
      },
      [tagEl]
    );
  }
});
// CONCATENATED MODULE: ./packages/tag/src/tag.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_tagvue_type_script_lang_js_ = (tagvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(2);

// CONCATENATED MODULE: ./packages/tag/src/tag.vue
var render, staticRenderFns




/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_tagvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/tag/src/tag.vue"
/* harmony default export */ var tag = (component.exports);
// CONCATENATED MODULE: ./packages/tag/index.js


/* istanbul ignore next */
tag.install = function (Vue) {
  Vue.component(tag.name, tag);
};

/* harmony default export */ var packages_tag = __webpack_exports__["default"] = (tag);

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */
/***/ (function(module, exports) {

module.exports = require("throttle-debounce/debounce");

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=template&id=7a44c642&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.visible,
          expression: "visible"
        }
      ],
      class: [
        "iw-select__group-item",
        "iw-select__group-item--" + _vm.select.size,
        {
          selected: _vm.itemSelected,
          "is-disabled": _vm.disabled || _vm.limitReached,
          hover: _vm.hover
        }
      ],
      on: {
        mouseenter: _vm.hoverItem,
        click: function($event) {
          $event.stopPropagation()
          return _vm.selectOptionClick($event)
        }
      }
    },
    [
      _vm._t("default", [
        _c("span", { attrs: { title: _vm.currentLabel } }, [
          _c("span", {
            class: [
              _vm.select.multiple ? "iw-checkbox" : "",
              _vm.select.multiple && _vm.itemSelected
                ? "iw-checkbox--checked"
                : ""
            ]
          }),
          _c(
            "em",
            {
              class: [_vm.select.multiple ? "iw-text" : ""],
              attrs: { title: _vm.currentLabel }
            },
            [_vm._v("\n        " + _vm._s(_vm.currentLabel) + "\n      ")]
          ),
          _c("i", { staticClass: "iw-select__item-icon" })
        ])
      ])
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=template&id=7a44c642&

// EXTERNAL MODULE: ./src/mixins/emitter.js
var emitter = __webpack_require__(5);

// EXTERNAL MODULE: ./src/utils/util.js
var util = __webpack_require__(3);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/option.vue?vue&type=script&lang=js&
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var optionvue_type_script_lang_js_ = ({
  mixins: [emitter["a" /* default */]],

  name: 'IwOption',

  componentName: 'IwOption',

  inject: ['select'],

  props: {
    value: {
      required: true
    },
    label: [String, Number],
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      index: -1,
      visible: true,
      hitState: false,
      hover: false
    };
  },


  computed: {
    isObject: function isObject() {
      return Object.prototype.toString.call(this.value).toLowerCase() === '[object object]';
    },
    currentLabel: function currentLabel() {
      return this.label || (this.isObject ? '' : this.value);
    },
    currentValue: function currentValue() {
      return this.value || this.label || '';
    },
    itemSelected: function itemSelected() {
      if (!this.select.multiple) {
        return this.isEqual(this.value, this.select.selectedValue);
      } else {
        return this.contains(this.select.selectedValue, this.value);
      }
    },
    limitReached: function limitReached() {
      if (this.select.multiple) {
        return !this.itemSelected && (this.select.selectedValue || []).length >= this.select.max && this.select.max > 0;
      } else {
        return false;
      }
    }
  },
  watch: {
    currentLabel: function currentLabel() {
      if (!this.select.remote) this.dispatch('IwSelect', 'setSelected');
    },
    value: function value(val, oldVal) {
      var _select = this.select,
          remote = _select.remote,
          valueKey = _select.optionProps.value;

      if (!remote) {
        if (valueKey && (typeof val === 'undefined' ? 'undefined' : _typeof(val)) === 'object' && (typeof oldVal === 'undefined' ? 'undefined' : _typeof(oldVal)) === 'object' && val[valueKey] === oldVal[valueKey]) {
          return;
        }
        this.dispatch('IwSelect', 'setSelected');
      }
    }
  },

  methods: {
    isEqual: function isEqual(a, b) {
      if (!this.isObject) {
        return a === b;
      } else {
        var valueKey = this.select.optionProps.value;
        return Object(util["n" /* getValueByPath */])(a, valueKey) === Object(util["n" /* getValueByPath */])(b, valueKey);
      }
    },
    contains: function contains() {
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var target = arguments[1];

      if (!this.isObject) {
        return arr && arr.indexOf(target) > -1;
      } else {
        var valueKey = this.select.optionProps.value;
        return arr && arr.some(function (item) {
          return Object(util["n" /* getValueByPath */])(item, valueKey) === Object(util["n" /* getValueByPath */])(target, valueKey);
        });
      }
    },
    hoverItem: function hoverItem() {
      if (!this.disabled) {
        this.select.hoverIndex = this.select.options.indexOf(this);
      }
    },
    selectOptionClick: function selectOptionClick() {
      if (this.disabled !== true) {
        this.dispatch('IwSelect', 'handleOptionClick', [this, true]);
      }
    },
    queryChange: function queryChange(query) {
      this.visible = new RegExp(Object(util["h" /* escapeRegexpString */])(query), 'i').test(this.currentLabel);
      if (!this.visible) {
        this.select.filteredOptionsCount--;
      }
    }
  },

  created: function created() {
    this.select.options.push(this);
    this.select.cachedOptions.push(this);
    this.select.optionsCount++;
    this.select.filteredOptionsCount++;

    this.$on('queryChange', this.queryChange);
  },
  beforeDestroy: function beforeDestroy() {
    var _select2 = this.select,
        selected = _select2.selected,
        multiple = _select2.multiple;

    var selectedOptions = multiple ? selected : [selected];
    var index = this.select.cachedOptions.indexOf(this);
    var selectedIndex = selectedOptions.indexOf(this);

    // if option is not selected, remove it from cache
    if (index > -1 && selectedIndex < 0) {
      this.select.cachedOptions.splice(index, 1);
    }
    this.select.onOptionDestroy(this.select.options.indexOf(this));
  }
});
// CONCATENATED MODULE: ./packages/select/src/option.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_optionvue_type_script_lang_js_ = (optionvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(2);

// CONCATENATED MODULE: ./packages/select/src/option.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_optionvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/select/src/option.vue"
/* harmony default export */ var src_option = __webpack_exports__["a"] = (component.exports);

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=template&id=0e4aade6&
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "inline-block" } },
    [
      _c(
        "iw-popover",
        {
          class:
            "iw-select iw-select--" +
            _vm.iwSize +
            (_vm.iwDisabled ? " iw-select--disabled" : "") +
            (_vm.className ? " " + _vm.className : "") +
            (!!_vm.options.length || _vm.emptyText ? "" : " empty"),
          attrs: {
            trigger: _vm.trigger,
            placement: _vm.placement,
            "append-to-body": _vm.appendToBody,
            "popper-class":
              "iw-select iw-select--" +
              _vm.iwSize +
              (_vm.iwDisabled ? " iw-select--disabled" : "") +
              (_vm.className ? " " + _vm.className : "") +
              (!!_vm.options.length || _vm.emptyText ? "" : " empty"),
            disabled: _vm.iwDisabled,
            width: null
          },
          model: {
            value: _vm.visible,
            callback: function($$v) {
              _vm.visible = $$v
            },
            expression: "visible"
          }
        },
        [
          _c(
            "div",
            {
              ref: "container",
              staticClass: "iw-select__reference",
              attrs: { slot: "reference" },
              slot: "reference"
            },
            [
              _c(
                "div",
                {
                  class: [
                    {
                      "is-focus": !_vm.iwDisabled && _vm.visible,
                      "is-disabled": _vm.iwDisabled,
                      "has-error": _vm.hasError
                    }
                  ],
                  style: _vm.inputWidth ? "width:" + _vm.inputWidth + "px" : ""
                },
                [
                  _vm.triggerText
                    ? _c(
                        "span",
                        { staticClass: "iw-input__value" },
                        [_c("font", [_vm._v(_vm._s(_vm.triggerText))])],
                        1
                      )
                    : _vm.multiple
                    ? _c(
                        "div",
                        {
                          ref: "tags",
                          staticClass: "iw-select__tags",
                          style: {
                            "max-width": _vm.inputWidth - 36 + "px",
                            width: "100%"
                          }
                        },
                        [
                          _vm.collapseTags && _vm.selected.length
                            ? _c("span", [
                                _c(
                                  "span",
                                  { staticClass: "iw-select__collapse-text" },
                                  [_vm._v(_vm._s(_vm.valueText))]
                                )
                              ])
                            : _vm._e(),
                          !_vm.collapseTags
                            ? _c(
                                "transition-group",
                                { on: { "after-leave": _vm.resetInputHeight } },
                                _vm._l(_vm.selected, function(item) {
                                  return _c(
                                    "iw-tag",
                                    {
                                      key: _vm.getValueKey(item),
                                      attrs: {
                                        closable: !_vm.iwDisabled,
                                        size: _vm.collapseTagSize,
                                        type: "info",
                                        "disable-transitions": ""
                                      },
                                      on: {
                                        close: function($event) {
                                          return _vm.deleteTag($event, item)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        { staticClass: "iw-select__tags-text" },
                                        [_vm._v(_vm._s(item.label))]
                                      )
                                    ]
                                  )
                                }),
                                1
                              )
                            : _vm._e(),
                          _vm.showSearch
                            ? _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.keyword,
                                    expression: "keyword"
                                  }
                                ],
                                ref: "input",
                                staticClass: "iw-select__input",
                                class: [_vm.iwSize ? "is-" + _vm.iwSize : ""],
                                attrs: {
                                  type: "text",
                                  disabled: _vm.iwDisabled,
                                  placeholder: _vm.valueText,
                                  readonly: _vm.readonly
                                },
                                domProps: { value: _vm.keyword },
                                on: {
                                  keyup: _vm.managePlaceholder,
                                  input: [
                                    function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.keyword = $event.target.value
                                    },
                                    _vm.debouncedQueryChange
                                  ]
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "iw-input",
                    {
                      ref: "reference",
                      class: { "is-focus": _vm.visible },
                      attrs: {
                        type: "text",
                        placeholder: _vm.currentPlaceholder,
                        size: _vm.iwSize,
                        disabled: _vm.iwDisabled,
                        readonly: _vm.readonly
                      },
                      nativeOn: {
                        keyup: function($event) {
                          return _vm.debouncedOnInputChange($event)
                        },
                        mouseenter: function($event) {
                          _vm.inputHovering = true
                        },
                        mouseleave: function($event) {
                          _vm.inputHovering = false
                        }
                      },
                      model: {
                        value: _vm.selectedLabel,
                        callback: function($$v) {
                          _vm.selectedLabel = $$v
                        },
                        expression: "selectedLabel"
                      }
                    },
                    [
                      _vm._v("\n        >\n          "),
                      _vm.$slots.prefix
                        ? _c(
                            "template",
                            { slot: "prefix" },
                            [_vm._t("prefix")],
                            2
                          )
                        : _vm._e(),
                      _c("template", { slot: "suffix" }, [
                        _c("i", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.showClose,
                              expression: "!showClose"
                            }
                          ],
                          class: [
                            "iw-select__caret",
                            "iw-input__icon",
                            "iw-icon-" + _vm.iconClass
                          ]
                        }),
                        _vm.showClose
                          ? _c("i", {
                              staticClass:
                                "iw-select__caret iw-input__icon iw-icon-circle-close",
                              on: { click: _vm.handleClearClick }
                            })
                          : _vm._e()
                      ])
                    ],
                    2
                  )
                ],
                1
              )
            ]
          ),
          !_vm.iwDisabled
            ? _c(
                "div",
                {
                  style: "min-width:" + (_vm.inputWidth - 2) + "px",
                  attrs: { id: "iw-select__popover--" + _vm.id }
                },
                [
                  _c("div", { staticClass: "iw-select__body" }, [
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.loading,
                            expression: "loading"
                          }
                        ]
                      },
                      [
                        _c(
                          "iw-scrollbar",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.options.length > 0 && !_vm.loading,
                                expression: "options.length > 0 && !loading"
                              }
                            ],
                            ref: "scrollbarRight__KEY",
                            attrs: { "wrap-class": "iw-select__wrap" }
                          },
                          [
                            _vm.multiple &&
                            _vm.showCheckAll &&
                            _vm.options.some(function(item) {
                              return item.visible
                            })
                              ? _c("ul", { staticClass: "iw-select__group" }, [
                                  _c(
                                    "li",
                                    {
                                      staticClass: "iw-select__group-item",
                                      class:
                                        "iw-select__group-item--" + _vm.iwSize,
                                      on: {
                                        click: function($event) {
                                          return _vm.handleCheckAllChange()
                                        }
                                      }
                                    },
                                    [
                                      _c("span", {
                                        class: [
                                          "iw-checkbox",
                                          _vm.isCheckAllChecked()
                                            ? "iw-checkbox--checked"
                                            : "",
                                          _vm.isCheckAllIndeterminate()
                                            ? "iw-checkbox--indeterminate"
                                            : ""
                                        ]
                                      }),
                                      _c(
                                        "span",
                                        {
                                          class: [_vm.multiple ? "iw-text" : ""]
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.t("iw.select.checkAll"))
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _c(
                              "ul",
                              { staticClass: "iw-select__group" },
                              [
                                _vm._t(
                                  "default",
                                  _vm._l(_vm.data, function(item, key) {
                                    return _c("iw-option", {
                                      key: key,
                                      attrs: {
                                        label: item[_vm.optionProps.label],
                                        value: item[_vm.optionProps.value]
                                      }
                                    })
                                  })
                                )
                              ],
                              2
                            )
                          ]
                        ),
                        _vm.emptyText
                          ? _c("ul", { staticClass: "iw-select__group" }, [
                              _c(
                                "li",
                                {
                                  staticClass: "iw-select__group-item",
                                  class: "iw-select__group-item--" + _vm.iwSize,
                                  on: {
                                    click: function($event) {
                                      _vm.visible = false
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "em",
                                    { staticClass: "iw-select__placeholder" },
                                    [_vm._v(_vm._s(_vm.t("iw.common.noMatch")))]
                                  )
                                ]
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _vm.multiple &&
                  _vm.showControl &&
                  _vm.options &&
                  _vm.options.filter(function(item) {
                    return item.visible !== false
                  }).length
                    ? _c(
                        "div",
                        { staticClass: "iw-select__footer" },
                        [
                          _c(
                            "iw-button",
                            {
                              attrs: { size: _vm.iwSize },
                              on: {
                                click: function($event) {
                                  return _vm.reset()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.t("iw.common.reset")) +
                                  "\n        "
                              )
                            ]
                          ),
                          _c(
                            "iw-button",
                            {
                              attrs: { size: _vm.iwSize, type: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.submit(false)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n          " +
                                  _vm._s(_vm.t("iw.common.confirm")) +
                                  "\n        "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ]
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true


// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=template&id=0e4aade6&

// EXTERNAL MODULE: ./src/utils/util.js
var util = __webpack_require__(3);

// EXTERNAL MODULE: ./src/mixins/locale.js
var locale = __webpack_require__(8);

// EXTERNAL MODULE: ./packages/select/src/option.vue + 4 modules
var src_option = __webpack_require__(26);

// EXTERNAL MODULE: ./src/mixins/emitter.js
var emitter = __webpack_require__(5);

// EXTERNAL MODULE: external "throttle-debounce/debounce"
var debounce_ = __webpack_require__(25);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce_);

// EXTERNAL MODULE: ./src/utils/resize-event.js
var resize_event = __webpack_require__(9);

// EXTERNAL MODULE: ./src/locale/index.js + 2 modules
var src_locale = __webpack_require__(11);

// EXTERNAL MODULE: ./packages/popover/index.js + 5 modules
var popover = __webpack_require__(20);

// EXTERNAL MODULE: ./packages/scrollbar/index.js + 3 modules
var scrollbar = __webpack_require__(18);

// EXTERNAL MODULE: ./packages/empty/index.js + 5 modules
var empty = __webpack_require__(21);

// EXTERNAL MODULE: ./packages/tag/index.js + 3 modules
var tag = __webpack_require__(22);

// EXTERNAL MODULE: ./packages/input/index.js + 6 modules
var packages_input = __webpack_require__(13);

// EXTERNAL MODULE: ./packages/button/index.js + 5 modules
var packages_button = __webpack_require__(15);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib??vue-loader-options!./packages/select/src/select.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














/* harmony default export */ var selectvue_type_script_lang_js_ = ({
  name: 'IwSelect',

  componentName: 'IwSelect',

  mixins: [emitter["a" /* default */], locale["a" /* default */]],
  components: {
    IwOption: src_option["a" /* default */],
    IwPopover: popover["default"],
    IwScrollbar: scrollbar["default"],
    IwEmpty: empty["default"],
    IwTag: tag["default"],
    IwInput: packages_input["default"],
    IwButton: packages_button["default"]
  },

  provide: function provide() {
    return {
      'select': this
    };
  },


  inject: {
    iwForm: {
      default: ''
    },
    iwFormItem: {
      default: ''
    }
  },

  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      required: true
    },
    defaultValue: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    id: {
      type: Number,
      default: function _default() {
        return parseInt(Math.random() * 10000);
      }
    },
    multiple: {
      // 是否多选模式
      type: Boolean,
      default: false
    },
    showCheckAll: {
      // 当此项为 true 时，显示顶部全选功能
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    beforeSave: {
      type: Function,
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    showSearch: {
      // 显示搜索框
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    showControl: {
      type: Boolean,
      default: true
    },
    remote: {
      type: Boolean,
      default: false
    },
    collapseTags: {
      type: Boolean,
      default: true
    },
    loadingText: String,
    noMatchText: String,
    noDataText: String,
    remoteMethod: {
      type: Function,
      default: function _default() {}
    },
    defaultFirstOption: Boolean,
    reserveKeyword: Boolean,
    status: {
      type: [Number, String],
      default: 0
    },
    optionProps: {
      type: Object,
      default: function _default() {
        return {
          label: 'value',
          value: 'key',
          children: 'children'
        };
      }
    },
    triggerText: {
      type: [String, Boolean],
      default: function _default() {
        return false;
      }
    },
    width: {
      type: [String, Number],
      default: function _default() {
        return null;
      }
    },
    placeholder: {
      type: String,
      default: function _default() {
        return Object(src_locale["a" /* t */])('iw.select.placeholder');
      }
    },
    max: {
      type: Number,
      default: 0
    },
    /**
     * Popover的属性
     */
    trigger: {
      // 触发方式， 可选：hover/focus/click/contextmenu
      type: String,
      default: 'click'
    },
    placement: {
      // 气泡框位置， 可选：top left right bottom topLeft topRight bottomLeft bottomRight leftTop leftBottom rightTop rightBottom
      type: String,
      default: ''
    },
    appendToBody: {
      // 是否插入至body下, 默认true
      type: Boolean,
      default: true
    },
    className: {
      type: String,
      default: ''
    },
    size: {
      // 组件尺寸
      type: String,
      default: '' // 可选: medium || small || mini
    }
  },
  data: function data() {
    return {
      visible: false, // 弹出层状态
      hasError: false,
      options: [],
      cachedOptions: [],
      keyword: '', // 查询值
      previousQuery: null,
      inputHovering: false,
      currentPlaceholder: '',
      selectedLabel: '',
      selected: this.multiple ? [] : {},
      selectedValue: this.multiple ? this.value.slice() : this.value,
      inputWidth: 0,
      initialInputHeight: 0,
      cachedPlaceHolder: '',
      optionsCount: 0,
      filteredOptionsCount: 0,
      isOnComposition: false
    };
  },

  computed: {
    _iwFormItemSize: function _iwFormItemSize() {
      return (this.iwFormItem || {}).iwFormItemSize;
    },
    iwSize: function iwSize() {
      return this.size || this._iwFormItemSize || (this.$IWAYS || {}).size;
    },
    iwDisabled: function iwDisabled() {
      return this.disabled || (this.iwForm || {}).disabled;
    },
    collapseTagSize: function collapseTagSize() {
      return ['small', 'mini'].indexOf(this.iwSize) > -1 ? 'mini' : 'small';
    },
    readonly: function readonly() {
      return !this.showSearch || !this.visible;
    },
    showClose: function showClose() {
      var hasValue = this.multiple ? Array.isArray(this.selectedValue) && this.selectedValue.length > 0 : this.selectedValue !== undefined && this.selectedValue !== null && this.selectedValue !== '';
      return this.clearable && !this.iwDisabled && this.inputHovering && hasValue;
    },
    iconClass: function iconClass() {
      return this.remote && this.showSearch ? '' : this.visible && !this.iwDisabled ? 'arrow-up is-reverse' : 'arrow-up';
    },
    debounce: function debounce() {
      return this.remote ? 300 : 0;
    },
    emptyText: function emptyText() {
      if (this.loading) {
        return this.loadingText || this.t('iw.select.loading');
      } else {
        if (this.remote && this.keyword === '' && this.options.length === 0) return false;
        if (this.showSearch && this.keyword && this.options.length > 0 && this.filteredOptionsCount === 0) {
          return this.noMatchText || this.t('iw.select.noMatch');
        }
        if (this.options.length === 0) {
          return this.noDataText || this.t('iw.select.noData');
        }
      }
      return null;
    },
    valueText: function valueText() {
      if (this.multiple && this.selected && this.selected.length > 0) {
        if (this.selected.length > 1) {
          return this.t('iw.common.selected') + '(' + this.selected.length + ')';
        } else {
          return this.selected[0].label;
        }
      } else if (!this.multiple) {
        return this.selected.label;
      } else {
        return '';
      }
    }
  },
  watch: {
    value: function value(val, oldVal) {
      this.selectedValue = this.multiple ? val.slice() : val;
      if (this.multiple) {
        this.resetInputHeight();
        if (val && val.length > 0 || this.$refs.input && this.keyword !== '') {
          this.currentPlaceholder = '';
        } else {
          this.currentPlaceholder = this.cachedPlaceHolder;
        }
        if (this.showSearch && !this.reserveKeyword) {
          this.keyword = '';
          this.handleQueryChange('');
        }
      }
      this.setSelected();
    },
    visible: function visible(val) {
      var _this = this;

      this.selectedValue = this.multiple ? this.value.slice() : this.value;
      if (!val) {
        this.keyword = '';
        this.previousQuery = null;
        this.selectedLabel = '';
        this.$nextTick(function () {
          if (_this.$refs.input && _this.$refs.input.value === '' && _this.selected.length === 0) {
            _this.currentPlaceholder = _this.cachedPlaceHolder;
          }
        });
        if (!this.multiple) {
          if (this.selected) {
            this.selectedLabel = this.selected.label;
            if (this.showSearch) this.keyword = this.selectedLabel;
          }

          if (this.showSearch) {
            this.currentPlaceholder = this.cachedPlaceHolder;
          }
        } else {
          this.keyword = this.valueText;
        }
      } else {
        if (this.multiple) {
          this.keyword = '';
        }
        if (this.showSearch) {
          this.keyword = this.remote ? '' : this.selectedLabel;
          this.handleQueryChange(this.keyword);
          if (this.multiple) {
            this.$refs.input.focus();
          } else {
            if (!this.remote) {
              this.broadcast('IwOption', 'queryChange', '');
            }
            if (this.selectedLabel) {
              this.currentPlaceholder = this.selectedLabel;
              this.selectedLabel = '';
            }
          }
        }
      }
    },
    options: function options() {
      if (this.$isServer) return;
      if (this.multiple) {
        this.resetInputHeight();
      }
      var inputs = this.$el.querySelectorAll('input');
      if ([].indexOf.call(inputs, document.activeElement) === -1) {
        this.setSelected();
      }
    },
    placeholder: function placeholder(val) {
      this.cachedPlaceHolder = this.currentPlaceholder = val;
    }
  },

  created: function created() {
    var _this2 = this;

    this.selectedValue = this.multiple ? this.value.slice() : this.value;
    this.cachedPlaceHolder = this.currentPlaceholder = this.placeholder;
    this.debouncedOnInputChange = debounce_default()(this.debounce, function () {
      _this2.onInputChange();
    });
    this.debouncedQueryChange = debounce_default()(this.debounce, function (e) {
      _this2.handleQueryChange(e.target.value);
    });

    this.$on('handleOptionClick', this.handleOptionSelect);
    this.$on('setSelected', this.setSelected);
  },
  mounted: function mounted() {
    var _this3 = this;

    if (this.multiple && Array.isArray(this.value) && this.value.length > 0) {
      this.currentPlaceholder = '';
    }
    Object(resize_event["a" /* addResizeListener */])(this.$el, this.handleResize);

    var reference = this.$refs.reference;
    if (reference && reference.$el) {
      var sizeMap = {
        medium: 32,
        small: 28,
        mini: 24
      };
      var input = reference.$el.querySelector('input');
      this.initialInputHeight = input.getBoundingClientRect().height || sizeMap[this.iwSize];
    }
    if (this.remote && this.multiple) {
      this.resetInputHeight();
    }
    this.$nextTick(function () {
      if (reference && reference.$el) {
        _this3.inputWidth = reference.$el.getBoundingClientRect().width;
      }
    });
    this.setSelected();
  },


  methods: {
    handleComposition: function handleComposition(event) {
      var _this4 = this;

      var text = event.target.value;
      if (event.type === 'compositionend') {
        this.isOnComposition = false;
        this.$nextTick(function (_) {
          return _this4.handleQueryChange(text);
        });
      } else {
        var lastCharacter = text[text.length - 1] || '';
        this.isOnComposition = !isKorean(lastCharacter);
      }
    },
    initStatus: function initStatus() {
      var _this5 = this;

      if (this.selectedValue.length) {
        var key = this.selectedValue[0];
        this.$nextTick(function () {
          _this5.scrollTop(key);
        });
      }
      if (this.showSearch && this.$refs.input) {
        this.$refs.input.focus();
      }
    },
    scrollTop: function scrollTop(key) {
      var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'SELECT';

      var obj = document.querySelector('#iw-select__popover--' + this.id + ' [scroll-key="' + key + '_' + target + '"]');
      if (obj) {
        var scrollTop = parseInt(obj['offsetTop']);
        document.querySelector('#iw-select__popover--' + this.id + ' .iw-select__wrap').scrollTop = scrollTop;
      }
    },
    handleQueryChange: function handleQueryChange(val) {
      var _this6 = this;

      if (this.previousQuery === val || this.isOnComposition) return;
      if (this.previousQuery === null && typeof this.remoteMethod === 'function') {
        this.previousQuery = val;
        return;
      }
      this.previousQuery = val;

      if (this.multiple && this.showSearch) {
        this.$nextTick(function () {
          var length = _this6.$refs.input.value.length * 15 + 20;
          _this6.managePlaceholder();
        });
      }
      if (this.remote && typeof this.remoteMethod === 'function') {
        this.hoverIndex = -1;
        this.remoteMethod(val);
      } else {
        this.filteredOptionsCount = this.optionsCount;
        this.broadcast('IwOption', 'queryChange', val);
      }
    },

    /**
     * 查询关键字，过滤数据源
     */
    onInputChange: function onInputChange() {
      if (this.showSearch && this.keyword !== this.selectedLabel) {
        this.keyword = this.selectedLabel;
        this.handleQueryChange(this.keyword);
      }
    },
    onOptionDestroy: function onOptionDestroy(index) {
      if (index > -1) {
        this.optionsCount--;
        this.filteredOptionsCount--;
        this.options.splice(index, 1);
      }
    },
    resetInputWidth: function resetInputWidth() {
      this.inputWidth = this.$refs.reference.$el.getBoundingClientRect().width;
    },
    handleResize: function handleResize() {
      this.resetInputWidth();
    },
    handleClearClick: function handleClearClick(event) {
      this.deleteSelected(event);
    },
    handleCheckAllChange: function handleCheckAllChange() {
      var selected = this.isCheckAllChecked();
      this.selectedValue = selected ? [] : this.options.map(function (item) {
        return item.value;
      });
      if (this.showSearch && this.$refs.input) {
        this.$refs.input.focus();
      }
    },
    isCheckAllChecked: function isCheckAllChecked() {
      var _this7 = this;

      var values = this.data.map(function (item) {
        return item[_this7.optionProps.value];
      });
      return values.every(function (value) {
        return _this7.selectedValue.includes(value);
      });
    },
    isCheckAllIndeterminate: function isCheckAllIndeterminate() {
      return this.selectedValue.length > 0 && this.selectedValue.length !== this.options.length;
    },
    reset: function reset() {
      var submit = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.selectedValue = this.defaultValue;
      if (submit === true) {
        this.submit();
      }
    },
    submit: function submit() {
      var visible = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.beforeSave && typeof this.beforeSave === 'function') {
        var value = this.beforeSave(this.selectedValue);
        if (Object.prototype.toString.call(value).toLowerCase() === '[object object]') {
          var error = value.error,
              message = value.message;

          if (error === true) {
            this.hasError = error;
            return;
          }
        }
      }
      this.$emit('input', this.selectedValue);
      this.emitChange(this.selectedValue);
      this.visible = visible;
    },
    substr: function substr(str, len) {
      return Object(util["r" /* substr */])(str, len);
    },
    setError: function setError() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.hasError = error;
    },
    deleteSelected: function deleteSelected(event) {
      event.stopPropagation();
      var value = this.multiple ? [] : '';
      this.$emit('input', value);
      this.emitChange(value);
      this.visible = false;
      this.currentPlaceholder = this.cachedPlaceHolder;
      this.$emit('clear');
    },
    deleteTag: function deleteTag(event, tag) {
      var index = this.selected.indexOf(tag);
      if (index > -1 && !this.iwDisabled) {
        var value = this.value.slice();
        value.splice(index, 1);
        this.$emit('input', value);
        this.emitChange(value);
        this.$emit('remove-tag', tag.value);
      }
      event.stopPropagation();
    },
    emitChange: function emitChange(val) {
      if (!Object(util["u" /* valueEquals */])(this.value, val)) {
        this.$emit('change', val);
      }
    },
    getOption: function getOption(value) {
      var option = void 0;
      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
      var isNull = Object.prototype.toString.call(value).toLowerCase() === '[object null]';
      var isUndefined = Object.prototype.toString.call(value).toLowerCase() === '[object undefined]';

      for (var i = this.cachedOptions.length - 1; i >= 0; i--) {
        var cachedOption = this.cachedOptions[i];
        var isEqual = isObject ? getValueByPath(cachedOption.value, this.optionProps.value) === getValueByPath(value, this.optionProps.value) : cachedOption.value === value;
        if (isEqual) {
          option = cachedOption;
          break;
        }
      }
      if (option) return option;
      var label = !isObject && !isNull && !isUndefined ? value : '';
      var newOption = {
        value: value,
        label: label
      };
      return newOption;
    },
    setSelected: function setSelected() {
      var _this8 = this;

      if (!this.multiple) {
        var option = this.getOption(this.selectedValue);
        this.selectedLabel = option.label;
        this.selected = option;
        if (this.showSearch) this.keyword = this.selectedLabel;
        return;
      }
      var result = [];
      if (Array.isArray(this.selectedValue)) {
        this.selectedValue.forEach(function (value) {
          result.push(_this8.getOption(value));
        });
      }
      this.selected = result;
      if (this.multiple) {
        this.keyword = this.valueText;
      }
      this.$nextTick(function () {
        _this8.resetInputHeight();
      });
    },
    managePlaceholder: function managePlaceholder() {
      if (this.currentPlaceholder !== '') {
        this.currentPlaceholder = this.$refs.input.value ? '' : this.cachedPlaceHolder;
      }
    },
    resetInputHeight: function resetInputHeight() {
      var _this9 = this;

      if (this.collapseTags && !this.showSearch) return;
      this.$nextTick(function () {
        if (!_this9.$refs.reference) return;
        var inputChildNodes = _this9.$refs.reference.$el.childNodes;
        var input = [].filter.call(inputChildNodes, function (item) {
          return item.tagName === 'INPUT';
        })[0];
        var tags = _this9.$refs.tags;
        var sizeInMap = _this9.initialInputHeight || 36;
        input.style.height = _this9.selected.length === 0 ? sizeInMap + 'px' : Math.max(tags ? tags.clientHeight + (tags.clientHeight > sizeInMap ? 6 : 0) : 0, sizeInMap) + 'px';
      });
    },
    handleOptionSelect: function handleOptionSelect(option, byClick) {
      if (this.multiple) {
        var value = (this.selectedValue || []).slice();
        var optionIndex = this.getValueIndex(value, option.value);
        if (optionIndex > -1) {
          value.splice(optionIndex, 1);
        } else if (this.max <= 0 || value.length < this.max) {
          value.push(option.value);
        }
        this.selectedValue = value.slice();
        if (!this.showControl) {
          this.$emit('input', value);
          this.emitChange(value);
          if (this.showSearch) this.$refs.input.focus();
        }
      } else {
        this.$emit('input', option.value);
        this.emitChange(option.value);
        this.visible = false;
      }
    },
    getValueIndex: function getValueIndex() {
      var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var value = arguments[1];

      var isObject = Object.prototype.toString.call(value).toLowerCase() === '[object object]';
      if (!isObject) {
        return arr.indexOf(value);
      } else {
        var valueKey = this.optionProps.value;
        var index = -1;
        arr.some(function (item, i) {
          if (getValueByPath(item, valueKey) === getValueByPath(value, valueKey)) {
            index = i;
            return true;
          }
          return false;
        });
        return index;
      }
    },
    getValueKey: function getValueKey(item) {
      if (Object.prototype.toString.call(item.value).toLowerCase() !== '[object object]') {
        return item.value;
      } else {
        return getValueByPath(item.value, this.optionProps.value);
      }
    }
  },

  beforeDestroy: function beforeDestroy() {
    if (this.$el && this.handleResize) Object(resize_event["b" /* removeResizeListener */])(this.$el, this.handleResize);
  }
});
// CONCATENATED MODULE: ./packages/select/src/select.vue?vue&type=script&lang=js&
 /* harmony default export */ var src_selectvue_type_script_lang_js_ = (selectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(2);

// CONCATENATED MODULE: ./packages/select/src/select.vue





/* normalize component */

var component = Object(componentNormalizer["a" /* default */])(
  src_selectvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (false) { var api; }
component.options.__file = "packages/select/src/select.vue"
/* harmony default export */ var src_select = (component.exports);
// CONCATENATED MODULE: ./packages/select/index.js


/* istanbul ignore next */
src_select.install = function (Vue) {
  Vue.component(src_select.name, src_select);
};

/* harmony default export */ var packages_select = __webpack_exports__["default"] = (src_select);

/***/ })
/******/ ]);